import React, { useEffect, useState, useRef } from "react"
import { useParams, withRouter } from "react-router-dom"
import { useSelector, connect, useDispatch } from "react-redux"
// import { useSelector, connect, useDispatch } from "react-redux"
import Select from "react-select"
import {
  Row,
  Col,
  UncontrolledTooltip,
  Button,
  Table,
  Label,
  Input,
  Nav,
} from "reactstrap"
//import * as quotationAction from "../../store/cXVvdGF0/actions"
import * as ecFollowupAction from "../../store/b3BlcmF0aW9uc0/actions"
import * as followupCloseAction from "../../store/b3BlcmF0aW9uc01hbmFnZUZ/actions"
import * as mobileAction from "../../store/bWFuYWdlSGlnaFZhbHV/actions"
import { ToastContainer, toast } from "react-toastify"
import { isEmpty, get } from "lodash"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import api from "helpers/Api"
import moment from "moment"
import SimpleReactValidator from "simple-react-validator"
import OperationsIssuesTab from "./OperationsIssuestab"
import imageNotFound from "../../assets/images/imageNotFound.png"

// import Modal from "react-bootstrap/Modal"

const OperationsFollowup = (props) => {
  const specificDispatch = useDispatch()
  let { id } = useParams()

  const { dispatch, modeMenu, record_client_profile } = props
  const crmLeadDetails = record_client_profile?.leadDetails || []
  const crmNotes = crmLeadDetails.find(m => m.leadId === id) // Use find to get a single object
  const crmNotesValue = crmNotes ? crmNotes.crmNotes : ""
  console.log(record_client_profile, "recordf")
  console.log(crmNotes, "crmNotes")
  console.log(crmNotesValue, "crmNotes")
  useEffect(() => {
    setCrmNotesData({
      crmNotes: crmNotesValue
    })
  }, [])
  const permissionUpdate = useSelector(
    (specificstate) => specificstate.manageHighValueLead
  )
  const {
    attachmentRecord = [],
  } = permissionUpdate
  const [followUpTab, setFollowUpTab] = useState("Operations Followup")
  let followUpButtons = [
    {
      label: "Operations Followup",
      color:
        followUpTab === "Operations Followup"
          ? "btn btn-success"
          : "btn btn-warning",
    },
    {
      label: "Issues Followup",
      color:
        followUpTab === "Issues Followup"
          ? "btn btn-success"
          : "btn btn-warning",
    },
  ]
  useEffect(() => {
    dispatch(ecFollowupAction.loadRecordsMetaData())
    dispatch(ecFollowupAction.loadCallCriteria({ type: "CRITERIA" }))
    dispatch(ecFollowupAction.loadcallActions({ type: "ACTION" }))
    dispatch(ecFollowupAction.loadDeliverableStatus({ leadId: id }))
    specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
    dispatch(ecFollowupAction.loadDeliverableTag({ status: "active" }))
    dispatch(mobileAction.loadRecordsAttachmentDetailData())
  }, [])

  const [mobileData, setMobileData] = useState({
    date: ""
  })
  const handleMobileChange = async (e) => {
    setMobileData({ ...mobileData, [e.target.name]: e.target.value })
  }
  const handleMobileSearch = (e) => {
    e.preventDefault()
    const payload = {
       pickDateFilter: mobileData.date?moment(mobileData.date).format("YYYY-MM-DD"):""
    }
    console.log(payload,"payload checking")
    dispatch(mobileAction.loadRecordsAttachmentDetailData(payload))
  }
  const handleMobileReset = (e) => {
    e.preventDefault()
    setMobileData({date:""})
 
    dispatch(mobileAction.loadRecordsAttachmentDetailData({}))
  }
  //date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate
  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)
  //Date format
  const dateSetting =
    !isEmpty(responseLogin) &&
      responseLogin.setting &&
      responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  const eta =
    !isEmpty(responseLogin) && responseLogin.setting && responseLogin.setting.crmETA
      ? responseLogin.setting.crmETA
      : !isEmpty(user) && user.setting && user.setting.crmETA
        ? user.setting.crmETA
        : ""

  const etaValue = eta && eta ? eta : ""
  //React Validations
  const simpleValidator = useRef(new SimpleReactValidator())

  const [, forceUpdate] = useState()
  //validations 2
  const simpleEscalationValidator = useRef(new SimpleReactValidator())
  const simpleCloseValidator = useRef(new SimpleReactValidator())

  const [, escalateForceUpdate] = useState()
  const [, closeForceUpdate] = useState()

  const ecUpdate = useSelector((state) => state.operationsFollowUp)

  const {
    recordsMetaData = {},
    followup_list = [],
    deliverStatusData = [],
    issuesDetails = [],
    criteria_data = [],
    actions_data = [],
    tagData = [],
  } = ecUpdate

  const [criteriaDetails, setCriteriaDetails] = useState("")
  const [actionsDetails, setActionsDetails] = useState("")

  const [crmNotesData, setCrmNotesData] = useState({
    crmNotes: ''
  })
  const handleCrmNotes = (e) => {
    setCrmNotesData({ ...crmNotesData, [e.target.name]: e.target.value })
  }
  const updateCrm = () => {
    const payload = {
      leadId: id,
      crmNotes: crmNotesData.crmNotes
    }
    dispatch(ecFollowupAction.updateNotes(payload))
    setTimeout(() => {
      //specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
      toast.success("CRM Notes Added successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 500)
  }
  const hintsOptions =
    tagData && !isEmpty(tagData) && tagData.length > 0
      ? tagData.map((data) => {
        return {
          label: data.deliverableTag,
          value: data._id,
          productCategoryId: data.deliverableProductCategoryId
        }
      })
      : []

  //
  const [followupStatusModal, setFollowupStatusModal] = useState(false)
  const [followupDetails, setFollowupDetails] = useState("")
  const submitFollowup = () => {
    setFollowupStatusModal(false)
    const update_details = {
      "followupId": followupDetails._id,
      "followupStatus": "CLOSED"
    }
    console.log(update_details)
    dispatch(followupCloseAction.updateFollowup(update_details))
    setTimeout(() => {
      specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
      toast.success("Followup Completed successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 500)
  }
  //Ec Followup State section

  const [ecFollowupModal, setECFollowupModal] = useState(false)

  const [isEdit, setIsEdit] = useState(false)
  //current date and time
  function addZeroBefore(number) {
    var numberString = "0" + number
    if (number < 10) {
      return numberString
    } else {
      return number
    }
  }

  var currentDateMoment = moment().format("YYYY-MM-DD")
  var currentHourMoment = addZeroBefore(moment().format("HH"))
  var currentMinuteMoment = addZeroBefore(moment().minutes())
  var currentDateTimeMoment =
    currentDateMoment + "T" + currentHourMoment + ":" + currentMinuteMoment
  //followup modal data
  const [followUpData, setFollowUpData] = useState({
    callDateAndTime: "",
    personContacted: "",
    followUpRemarks: "",

  })

  const [preferredLanguage, setPreferredLanguage] = useState([])

  const handleFollowUpChange = async (e) => {
    setFollowUpData({ ...followUpData, [e.target.name]: e.target.value })
  }
  //future followup data
  const [futureFollowUpData, setFutureFollowUpData] = useState({
    nextFollowUpDateAndTime: "",
    remarks: "",
  })
  useEffect(() => {
    setFollowUpData({
      ...followUpData,
      callDateAndTime: currentDateTimeMoment,
    })
    setFutureFollowUpData({
      ...futureFollowUpData,
      nextFollowUpDateAndTime: currentDateTimeMoment,
    })
  }, [])
  const [futureFollowUpMode, setFutureFollowUpMode] = useState([])
  const handleFutureFollowUpChange = (e) => {
    setFutureFollowUpData({
      ...futureFollowUpData,
      [e.target.name]: e.target.value,
    })
  }
  //call type
  const [callType, setCallType] = useState([])
  const callTypeOptions = [
    { label: "Outbound", value: "Outbound" },
    { label: "Inbound", value: "Inbound" },
  ]

  const [inBoundType, setInBoundType] = useState([])
  const inBoundTypeOptions = [
    { label: "Changes Request", value: "Changes Request" },
    { label: "Feedback", value: "Feedback" },
    { label: "Escalation", value: "Escalation" },
    { label: "General Followup", value: "General Followup" },
    { label: "Query", value: "Query" },
    { label: "Others", value: "Others" },
  ]

  //escalation mode
  const [escalationMode, setEscalationMode] = useState([])
  const escalationModeOptions = [
    { label: "Google Review", value: "Google Review" },
    { label: "Insta DM", value: "Insta DM" },
    { label: "Mail", value: "Mail" },
    { label: "Whatsapp Group", value: "Whatsapp Group" },
    { label: "Phone Call", value: "Phone Call" },
    { label: "Whatsapp Call", value: "Whatsapp Call" },
    { label: "Office Visit", value: "Office Visit" },
  ]
  // checkbox
  const [checkedItems, setCheckedItems] = useState([])

  const handleCheckboxChange = (item) => {
    const isChecked = checkedItems.some(
      (checkedItem) => checkedItem._id === item._id
    )

    if (isChecked) {
      const updatedCheckedItems = checkedItems.filter(
        (checkedItem) => checkedItem._id !== item._id
      )
      setCheckedItems(updatedCheckedItems)
    } else {
      const updatedCheckedItems = [...checkedItems, item]
      setCheckedItems(updatedCheckedItems)
    }
  }

  const [checkedIntroItems, setCheckedIntroItems] = useState([])

  const handleIntroCheckboxChange = (item) => {
    const isChecked = checkedIntroItems.some(
      (checkedItem) => checkedItem._id === item._id
    )

    if (isChecked) {
      const updatedCheckedItems = checkedIntroItems.filter(
        (checkedItem) => checkedItem._id !== item._id
      )
      setCheckedIntroItems(updatedCheckedItems)
    } else {
      const updatedCheckedItems = [...checkedIntroItems, item]
      setCheckedIntroItems(updatedCheckedItems)
    }
  }
  //DelieverableStatusSection

  const [deliverableStatusSectionData, setDeliverableStatusSectionData] =
    useState([
      {
        _id: "",
        productId: "",
        productCategoryId: "",
        productName: "",
        applicableEvents: "",
        quantity: "",
        deliverableStatus: "",
        tatDate: "",
        hintsId: [],
        hintsName: [],
        remarks: "",
        highlightedHints: [],
        hintStatus: []
      },
    ])
  // const resetDeliverableStatusSectionData = () => {
  //   setDeliverableStatusSectionData((prevData) =>
  //     prevData.map((item) => ({
  //       ...item,
  //       hintsId: [],
  //       hintsName: [],
  //       remarks: "",
  //     }))
  //   )
  // }
  //dropdown select modal
  const [dropDownModal, setDropDownModal] = useState(false)
  const [followUpModalDetails, setFollowUpModalDetails] = useState([])
  const [dropdownValue, setDropdownValue] = useState([])
  const [selectOpen, setSelectOpen] = useState(false)
  const [validateDepartment, setValidateDepartment] = useState(false)
  //Add Followup modal
  const addFollowupModalDetails = () => {
    setIsEdit(false)
    setValidateDepartment(false)
    setECFollowupModal(true)

    setDropdownValue(followUpModalDetails.value)
    setSelectOpen(true)
    setFollowUpData({
      callDateAndTime: currentDateTimeMoment,
      personContacted: "",
      followUpRemarks: "",
    })
    setFutureFollowUpData({
      nextFollowUpDateAndTime: currentDateTimeMoment,
      remarks: "",
    })
    setFollowUpMode([])
    setFutureFollowUpMode([])
    setPreferredLanguage([])
    setCallType([])
    setInBoundType([])
    setEscalationMode([])
    setIsEscalation(false)
    setFollowupReason([])
    setFileName("")
    setFileLength("")
    setCriteriaDetails(criteria_data)
    setActionsDetails(actions_data)
    setUploadInput([])
    setRadioOption({ option: "", checked: "" })
    setCheckedItems([])
    setCheckedIntroItems([])
    setIssuesData([
      {
        departmentId: "",
        department: "",
        issueDescription: "",
        followUpCommentsId: "",
        followUpComments: "",
        nextFollowUpDate: "",
        empId: [],
        empName: [],
        solutionOffered: "",
      },
    ])
    dispatch(ecFollowupAction.loadIssues({ leadId: id }))
  }

  useEffect(() => {
    setCriteriaDetails(criteria_data)
    setActionsDetails(actions_data)
  }, [])

  const clearFollowupModal = () => {
    setFollowUpModalDetails("")
    setSelectOpen(false)
    setFollowUpData({
      callDateAndTime: currentDateTimeMoment,
      personContacted: "",
      followUpRemarks: "",
    })
    setFutureFollowUpData({
      nextFollowUpDateAndTime: currentDateTimeMoment,
      remarks: "",
    })
    setIsEscalation(false)
    setFollowupReason([])
    setFollowUpMode([])
    setFutureFollowUpMode([])
    setPreferredLanguage([])
    setCallType([])
    setInBoundType([])
    setEscalationMode([])
    setFileName("")
    setFileLength("")
    setUploadInput([])
    setRadioOption({ option: "", checked: "" })
    setCheckedItems([])
    setCheckedIntroItems([])
    setIssuesData([
      {
        departmentId: "",
        department: "",
        issueDescription: "",
        followUpCommentsId: "",
        followUpComments: "",
        nextFollowUpDate: "",
        empId: [],
        empName: [],
        solutionOffered: "",
      },
    ])
  }
  //folowwup dropdown initial state
  const [followUpMode, setFollowUpMode] = useState([])
  // const [followupId, setFollowupId] = useState("")

  //const [followUpStatus, setFollowUpStatus] = useState([])

  const [uploadInput, setUploadInput] = useState([])

  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")

  //Connect options
  //dynamic radio button 1
  const [radioOption, setRadioOption] = useState({ option: "", checked: "" })

  const connectOptions = [
    { id: 1, option: "Completed", label: "Completed" },
    { id: 2, option: "Not Completed", label: "Not Completed" },
    { id: 3, option: "Call Back", label: "Call Back" },
  ]

  const handleOptionsChange = (e, index) => {
    let value = connectOptions[index].option
    setRadioOption({ option: value, checked: index })
  }
  const [followupReason, setFollowupReason] = useState([])
  //isEscalation checkbox
  const [isEscalation, setIsEscalation] = useState("")

  const statusList = [
    {
      label: "Is Escalation",
      value: true,
    },
  ]

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setIsEscalation(value)
    } else {
      setIsEscalation(false)
    }
  }
  //Attachment Change

  const [mobileAttachmentForm, setMobileAttachmentForm] = useState(false)
  const [mobileAttachmentSelected, setMobileAttachmentSelected] = useState([])
  const [attachmentValidation, setAttachmentValidation] = useState(false)

  //ref for attachment
  const inputDesktopAttachmentFile = useRef(null)
  const uploadChange = async (e, renderPage) => {

    if (e.target.files) {

      await setMobileAttachmentSelected([])
      setUploadInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadInput(teamUploadValue)
            await setRenderPage(!renderPage)
          }
        })

        await setAttachmentValidation(false)
        await setMobileAttachmentForm(false)
      }
    }
  }
  // handle click for mobile or desktop
  const handleClickAttachment = (value) => {
    if (value === "desktop" && inputDesktopAttachmentFile.current) {
      inputDesktopAttachmentFile.current.click()
      setUploadInput([])
    }
    if (value === "mobile") {
      setMobileAttachmentForm(true)
      setMobileData({
        date:""
      })
      setMobileAttachmentSelected([])
    }
  }

  // const handleClickAttachment = async (value) => {
  //   if (value == "desktop") {
  //     await setUploadInput([])
  //     if (inputDesktopAttachmentFile.current) {
  //       inputDesktopAttachmentFile.current.click()
  //     }
  //   }
  //   if (value == "mobile") {
  //     setMobileAttachmentForm(true)
  //     setMobileAttachmentSelected([])
  //   }
  // }
  const handleCloseAttachment = () => {
    setMobileAttachmentForm(false)
    setMobileAttachmentSelected([])
  }
  const handleSubmitAttachment = async () => {
    setMobileAttachmentForm(false)
  }
  //mobile attachment modal checkbox onchange functionality
  const handleChangeAttachmentCheckbox = async (
    e,
    valueId,
    valueAttachment
  ) => {
    setUploadInput([])
    var selectedValue = mobileAttachmentSelected
    if (e.target.checked) {
      selectedValue.push({ id: valueId, attachment: valueAttachment })
    } else {
      const index = selectedValue.indexOf(valueId)
      if (index > -1) {
        selectedValue.splice(index, 1)
      }
    }
    setMobileAttachmentSelected(selectedValue)
    setAttachmentValidation(false)
    setRenderPage(!renderPage)
  }
  //Attatchment Data
  const attachmentRecordUpdated = !isEmpty(attachmentRecord)
    ? attachmentRecord.map((attachment, index) => {
      var attachmentFile = attachment.attachment
      var attachmentFileExtenstion = attachmentFile.split(".")
      var attachmentFileExtenstionType =
        attachmentFileExtenstion[attachmentFileExtenstion.length - 1]
      var attachmentType = "file"

      if (attachmentFileExtenstionType) {
        if (
          attachmentFileExtenstionType == "jpg" ||
          attachmentFileExtenstionType == "png" ||
          attachmentFileExtenstionType == "jpeg"
        ) {
          attachmentType = "image"
        } else if (
          attachmentFileExtenstionType == "mp3" ||
          attachmentFileExtenstionType == "wav" ||
          attachmentFileExtenstionType == "mp4" ||
          attachmentFileExtenstionType == "m4a" ||
          attachmentFileExtenstionType == "m4b" ||
          attachmentFileExtenstionType == "msv" ||
          attachmentFileExtenstionType == "mmf" ||
          attachmentFileExtenstionType == "m4p" ||
          attachmentFileExtenstionType == "wma" ||
          attachmentFileExtenstionType == "aac" ||
          attachmentFileExtenstionType == "ac3" ||
          attachmentFileExtenstionType == "aiff" ||
          attachmentFileExtenstionType == "flac" ||
          attachmentFileExtenstionType == "ogg" ||
          attachmentFileExtenstionType == "opus" ||
          attachmentFileExtenstionType == "ts" ||
          attachmentFileExtenstionType == "wav" ||
          attachmentFileExtenstionType == "amr"
        ) {
          attachmentType = "audio"
        }
      }

      return {
        key: index,
        id: get(attachment, "_id", ""),
        customerDetails: get(attachment, "customerDetails", ""),
        description: get(attachment, "description", ""),
        pickDateTime: get(attachment, "pickDateTime", ""),
        attachment: get(attachment, "attachment", ""),
        attachmentType: attachmentType,
      }
    })
    : []
  //attchment end
  useEffect(() => {
    const deliverData = !isEmpty(deliverStatusData)
      ? deliverStatusData.map((data) => {
        const applicableEvents =
          data && data.applicableEventsDetails.length > 0
            ? data.applicableEventsDetails.map((m) => m.eventName).join(", ")
            : "--"
        const hintsId =
          data && data.hints.length > 0 ? data.hints.map((m) => m.id) : []
        const hintsName =
          data && data.hintsDetails.length > 0
            ? data.hintsDetails.map((m) => m.deliverableTag)
            : []
        const highlighted = data && data.hints.length > 0 ? data.hints.filter((m) => m.status == 2) : []
        const highlightedIds = !isEmpty(highlighted) ? highlighted.map(m => m.id) : []
        const tat = data.tatDate ? moment(data.tatDate) : ""
        const etaDate = tat
          ? tat.add(etaValue, "days").format(dateFormate)
          : ""
        return {
          _id: data._id,
          productId: data.product,
          productCategoryId: data.productCategoryId ? data.productCategoryId : "",
          productName: data.productName ? data.productName : "",
          applicableEvents: applicableEvents,
          quantity: data.quantity,
          deliverableStatus: data.deliverableStatus,
          tatDate: etaDate
            ? etaDate
            : "",
          hintsId: hintsId,
          hintsName: hintsName,
          remarks: data.remarks,
          highlightedHints: highlightedIds
        }
      })
      : []

    setDeliverableStatusSectionData(deliverData)
  }, [deliverStatusData])

  const [renderPage, setRenderPage] = useState(false)
  const modalChange = (e, index, name) => {

    const updatedServiceList = deliverableStatusSectionData.map((item, idx) => {
      if (idx === index) {
        const updatedItem = { ...item }

        if (name === "remarks") {
          updatedItem[name] = e.target.value
        }

        // Handle hintsId
        if (name === "hintsId") {
          const selectedOptions = Array.isArray(e) ? e : [e]
          const newHintsId = selectedOptions.map(option => option.value)

          const removedHints = updatedItem.hintsId.filter(id => !newHintsId.includes(id))

          removedHints.forEach((removedHint) => {
            if (!updatedItem.highlightedHints) {
              updatedItem.highlightedHints = []
            }

            if (!updatedItem.highlightedHints.includes(removedHint)) {
              updatedItem.highlightedHints.push(removedHint)
              newHintsId.push(removedHint)
            } else {
              updatedItem.highlightedHints = updatedItem.highlightedHints.filter(hint => hint !== removedHint)
            }
          })

          updatedItem.hintsId = newHintsId
          updatedItem.hintsName = newHintsId.map(id =>
            hintsOptions.find(option => option.value === id)?.label || "--"
          )
        }

        return updatedItem
      }

      return item
    })

    // Update the state 
    setDeliverableStatusSectionData(updatedServiceList)
    setRenderPage(!renderPage)
  }


  // const modalChange = async (e, index, name) => {
  //   var serviceList = deliverableStatusSectionData

  //   if (name === "remarks") {
  //     serviceList[index][name] = e.target.value
  //   }
  //   const selectedOptions = Array.isArray(e) ? e : [e] // Ensure e is an array
  //   const selectedValues = selectedOptions.map((option) => ({
  //     value: option.value,
  //     label: option.label,
  //   }))

  //   if (name === "hintsId") {
  //     setDeliverableStatusSectionData((prevIssuesData) => {
  //       const updatedIssuesData = [...prevIssuesData]
  //       updatedIssuesData[index]["hintsId"] = selectedValues.map(
  //         (option) => option.value
  //       )
  //       updatedIssuesData[index]["hintsName"] = selectedValues.map(
  //         (option) => option.label
  //       )
  //       return updatedIssuesData
  //     })

  //   }
  //   setRenderPage(!renderPage)
  // }


  //issues
  const [issuesData, setIssuesData] = useState([
    {
      departmentId: "",
      department: "",
      issueDescription: "",
      followUpCommentsId: "",
      followUpComments: "",
      nextFollowUpDate: "",
      empId: [],
      empName: [],
      solutionOffered: "",
    },
  ])

  const issuesModalChange = async (e, index, name) => {
    var issuesList = [...issuesData]

    if (
      name === "issueDescription" ||
      name === "nextFollowUpDate" ||
      name === "solutionOffered" ||
      name === "followUpComments"
    ) {
      issuesList[index][name] = e.target.value
    }
    if (name === "departmentId") {
      if (e) {
        issuesList[index]["departmentId"] = e.value
        issuesList[index]["department"] = e.label
      } else {
        issuesList[index]["departmentId"] = ""
        issuesList[index]["department"] = ""
      }
    }

    if (name === "empId") {
      const selectedOptions = Array.isArray(e) ? e : e ? [e] : [] // Ensure e is an array or empty if null
      const selectedValues = selectedOptions.map((option) => ({
        value: option.value,
        label: option.label,
      }))

      setIssuesData((prevIssuesData) => {
        const updatedIssuesData = [...prevIssuesData]
        updatedIssuesData[index]["empId"] = selectedValues.map(
          (option) => option.value
        )
        updatedIssuesData[index]["empName"] = selectedValues.map(
          (option) => option.label
        )
        return updatedIssuesData
      })
    }
    setIssuesData(issuesList)
    setRenderPage(!renderPage)
  }

  //add on issues
  const addIssues = () => {
    setIssuesData([
      ...issuesData,
      {
        departmentId: "",
        department: "",
        issueDescription: "",
        followUpCommentsId: "",
        followUpComments: "",
        nextFollowUpDate: "",
        empId: "",
        empName: "",
        solutionOffered: "",
      },
    ])
    setRenderPage(!renderPage)
  }

  const removeIssuesdetails = async (toRemove) => {
    var paymentList = issuesData
    if (toRemove != 0) {
      if (toRemove > -1) {
        paymentList.splice(toRemove, 1)
      }
      setIssuesData(paymentList)
      setRenderPage(!renderPage)
    }
  }

  /// list issues data
  const [issuesListData, setIssuesListData] = useState([
    {
      departmentId: "",
      department: "",
      issueDescription: "",
      followUpCommentsId: "",
      followUpComments: "",
      nextFollowUpDate: "",
      empId: [],
      empName: [],
      solutionOffered: "",
      createdDate: "",
      lastUpdatedDate: "",
      currentStatusName: "",
      currentStatusValue: "",

    },
  ])
  const issuesExistingTable = !isEmpty(issuesDetails)
    ? issuesDetails.map((data) => {
      const nextFollowupDate = !isEmpty(data.nextFollowupDate)
        ? moment(data.nextFollowUpDate).format(dateFormate)
        : "--"
      const createdOn = !isEmpty(data.createdOn)
        ? moment(data.createdOn).format(dateFormate)
        : "--"
      const updatedOn = !isEmpty(data.updatedOn)
        ? moment(data.updatedOn).format(dateFormate)
        : "--"
      const empId = data.poc && data.poc.map((m) => m)
      const empName = empId
        .map((emp) => {
          const empLabel =
            !isEmpty(recordsMetaData) &&
            recordsMetaData.employeeOptions
              .find((lab) => lab.value === emp)
              .label.toString()
          return empLabel
        })
        .join(",")


      return {
        departmentId: data.department,
        department: data.departmentName,
        issueDescription: data.issuesDescription,
        followUpCommentsId: "",
        followUpComments: data.internalFollowupComment,
        nextFollowUpDate: nextFollowupDate,
        empId: empId,
        empName: empName,
        solutionOffered: data.solutionOffered,
        createdDate: createdOn,
        lastUpdatedDate: updatedOn,
        currentStatusName: data.currentStatus,
        currentStatusValue: data.currentStatus,
      }
    })
    : []



  const preferredLanguageValue = !isEmpty(preferredLanguage)
    ? preferredLanguage.map((l) => l.value)
    : []
  const issuesAddData =
    !isEmpty(issuesData) && issuesData.length > 0
      ? issuesData
        .map((data) => {
          if (data) {
            // Only return the object if at least one field has data
            if (
              !isEmpty(data.departmentId) ||
              !isEmpty(data.issueDescription) ||
              !isEmpty(data.followUpComments) ||
              !isEmpty(data.nextFollowUpDate) ||
              !isEmpty(data.empId) ||
              !isEmpty(data.solutionOffered)
            ) {
              return {
                leadId: id,
                department: data.departmentId,
                issuesDescription: data.issueDescription,
                internalFollowupComment: data.followUpComments,
                nextFollowupDate: data.nextFollowUpDate
                  ? moment(data.nextFollowUpDate).format("YYYY-MM-DD")
                  : "",
                poc: data.empId,
                solutionOffered: data.solutionOffered,
              }
            }
          }
        })
        .filter(Boolean)
      : []
  //deliverable section
  const deliverableSectionValue = !isEmpty(deliverableStatusSectionData)
    ? deliverableStatusSectionData.map((data) => {
      const hintsIdValue =
        data.hintsId &&
        data.hintsId.map((id) => {
          return {
            id: id,
            status: data.highlightedHints?.includes(id) ? 2 : 1,
          }
        })
      return {
        _id: data._id,
        hints: hintsIdValue,
        remarks: data.remarks,
        productCategoryId: data.productCategoryId

      }
    })
    : []

  const criteriaValue = !isEmpty(checkedItems)
    ? checkedItems.map((data) => data._id)
    : []
  const actionValue = !isEmpty(checkedIntroItems)
    ? checkedIntroItems.map((data) => data._id)
    : []

  const followupReasons = !isEmpty(followupReason) ? followupReason.map(m => m.value) : ""
  console.log(followupReason, "followupreason")
  //Add EC FOllowup
  const addFollowup = (e) => {
    e.preventDefault()
    const callDateTime = moment(followUpData.callDateAndTime)
    const followupDate = moment(followUpData.callDateAndTime).format(
      "YYYY-MM-DD"
    )
    const time = callDateTime.format("h:mmA")

    const shouldValidateDepartment = issuesAddData.some((issue) => {
      return (
        isEmpty(issue.department) &&
        (!isEmpty(issue.issuesDescription) ||
          !isEmpty(issue.internalFollowupComment) ||
          !isEmpty(issue.nextFollowupDate) ||
          !isEmpty(issue.poc) ||
          !isEmpty(issue.solutionOffered))
      )
    })

    setValidateDepartment(shouldValidateDepartment)

    const allValid = simpleValidator.current.allValid()
    var AttachmentValue = []
    if (uploadInput && uploadInput.length > 0) {
      uploadInput.map((data) => {
        AttachmentValue.push(data)
      })
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
    }
    const attachmentValidation =
      (!uploadInput || uploadInput.length === 0) &&
      (!mobileAttachmentSelected || mobileAttachmentSelected.length === 0)
    setAttachmentValidation(attachmentValidation)

    if (allValid && !shouldValidateDepartment &&
      !attachmentValidation) {
      let operationsFollowupData = {
        leadId: id,
        followupDate: followupDate,
        followupType: followUpModalDetails.value,
        time: time,
        followupMode: followUpMode.value,
        reachStatus: radioOption.option,
        followupRemarks: followUpData.followUpRemarks,
        futureFollowupRemarks: futureFollowUpData.remarks,
        attachment: AttachmentValue,
        personContacted: followUpData.personContacted,
        preferredLanguage: preferredLanguageValue,
        futureFollowUpDate: futureFollowUpData.nextFollowUpDateAndTime,
        futureModeOfFollowup: futureFollowUpMode.value,
        callCriteria: criteriaValue,
        action: actionValue,
        issues: issuesAddData.length > 0 ? issuesAddData : [],
        deliverableStateSection: deliverableSectionValue,
        isEscalation: isEscalation,
        ...(followupReasons && { followupReason: followupReasons })
      }
      setUploadInput([])
      setMobileAttachmentSelected([])
      specificDispatch(
        ecFollowupAction.addOperationsFollowup(operationsFollowupData)
      )
      setTimeout(() => {
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setECFollowupModal(false)
        clearFollowupModal()
        specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
        //    resetDeliverableStatusSectionData()
      }, 1500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setECFollowupModal(true)
    }
  }

  //add escalation or followup
  const addEscalation = (e) => {
    e.preventDefault()
    const callDateTime = moment(followUpData.callDateAndTime)
    const followupDate = moment(followUpData.callDateAndTime).format(
      "YYYY-MM-DD"
    )
    const time = callDateTime.format("h:mmA")
    //future followup date

    const shouldValidateDepartment = issuesAddData.some((issue) => {
      return (
        isEmpty(issue.department) &&
        (!isEmpty(issue.issuesDescription) ||
          !isEmpty(issue.internalFollowupComment) ||
          !isEmpty(issue.nextFollowupDate) ||
          !isEmpty(issue.poc) ||
          !isEmpty(issue.solutionOffered))
      )
    })

    setValidateDepartment(shouldValidateDepartment)

    // Validate the form fields and conditionally check the department field
    const allValid = simpleEscalationValidator.current.allValid()
    var AttachmentValue = []
    if (uploadInput && uploadInput.length > 0) {
      uploadInput.map((data) => {
        AttachmentValue.push(data)
      })
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
    }
    const attachmentValidation =
      (!uploadInput || uploadInput.length === 0) &&
      (!mobileAttachmentSelected || mobileAttachmentSelected.length === 0)
    setAttachmentValidation(attachmentValidation)

    if (allValid && !shouldValidateDepartment && !attachmentValidation) {
      let operationsFollowupData = {
        leadId: id,
        followupDate: followupDate,
        followupType: followUpModalDetails.value,
        time: time,
        followupMode: followUpMode.value,
        modeOfEscalation: escalationMode.value,
        callType: callType.value,
        inBoundType: inBoundType.value,
        reachStatus: radioOption.option,
        attachment: AttachmentValue,
        personContacted: followUpData.personContacted,
        preferredLanguage: preferredLanguageValue,
        futureFollowUpDate: futureFollowUpData.nextFollowUpDateAndTime,
        futureModeOfFollowup: futureFollowUpMode.value,
        futureFollowupRemarks: futureFollowUpData.remarks,
        issues: issuesAddData.length > 0 ? issuesAddData : [],
        deliverableStateSection: deliverableSectionValue,
        isEscalation: isEscalation,
        ...(followupReasons && { followupReason: followupReasons })
      }
      if (followUpModalDetails.value === "Escalation") {
        operationsFollowupData.escalationRemarks = followUpData.followUpRemarks
      } else if (followUpModalDetails.value === "Followup") {
        operationsFollowupData.followupRemarks = followUpData.followUpRemarks
      }

      specificDispatch(
        ecFollowupAction.addOperationsFollowup(operationsFollowupData)
      )
      setTimeout(() => {
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setECFollowupModal(false)
        clearFollowupModal()
        specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
        //    resetDeliverableStatusSectionData()
      }, 1500)
    } else {
      simpleEscalationValidator.current.showMessages()
      escalateForceUpdate(1)
      setECFollowupModal(true)
    }
  }
  //add closure
  const addClosure = (e) => {
    e.preventDefault()
    const callDateTime = moment(followUpData.callDateAndTime)
    const followupDate = moment(followUpData.callDateAndTime).format(
      "YYYY-MM-DD"
    )
    const time = callDateTime.format("h:mmA")

    const shouldValidateDepartment = issuesAddData.some((issue) => {
      return (
        isEmpty(issue.department) &&
        (!isEmpty(issue.issuesDescription) ||
          !isEmpty(issue.internalFollowupComment) ||
          !isEmpty(issue.nextFollowupDate) ||
          !isEmpty(issue.poc) ||
          !isEmpty(issue.solutionOffered))
      )
    })

    setValidateDepartment(shouldValidateDepartment)
    const allValid = simpleCloseValidator.current.allValid()
    var AttachmentValue = []
    if (uploadInput && uploadInput.length > 0) {
      uploadInput.map((data) => {
        AttachmentValue.push(data)
      })
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
    }
    const attachmentValidation =
      (!uploadInput || uploadInput.length === 0) &&
      (!mobileAttachmentSelected || mobileAttachmentSelected.length === 0)
    setAttachmentValidation(attachmentValidation)
    if (allValid && !shouldValidateDepartment && !attachmentValidation) {
      let operationsFollowupData = {
        leadId: id,
        followupDate: followupDate,
        followupType: followUpModalDetails.value,
        time: time,
        followupMode: followUpMode.value,
        reachStatus: radioOption.option,
        followupRemarks: followUpData.followUpRemarks,
        attachment: AttachmentValue,
        personContacted: followUpData.personContacted,
        preferredLanguage: preferredLanguageValue,
        futureFollowUpDate: futureFollowUpData.nextFollowUpDateAndTime,
        futureModeOfFollowup: futureFollowUpMode.value,
        futureFollowupRemarks: futureFollowUpData.remarks,
        action: actionValue,
        issues: issuesAddData.length > 0 ? issuesAddData : [],
        deliverableStateSection: deliverableSectionValue,
        isEscalation: isEscalation,
        ...(followupReasons && { followupReason: followupReasons })
      }

      specificDispatch(
        ecFollowupAction.addOperationsFollowup(operationsFollowupData)
      )
      setTimeout(() => {
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setECFollowupModal(false)
        clearFollowupModal()
        specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
        // resetDeliverableStatusSectionData()
      }, 1500)
    } else {
      simpleCloseValidator.current.showMessages()
      closeForceUpdate(1)
      setECFollowupModal(true)
    }
  }
  //Edit EC FOllowup
  const editFollowup = (followup) => {
    setECFollowupModal(true)
    setValidateDepartment(false)
    setFollowUpModalDetails({
      label: followup.followupType,
      value: followup.followupType,
    })

    const followupReasonValue = followup && !isEmpty(followup.followupReason) ?
      followup.followupReason.map(
        (item) => {
          return {
            label: item.reasonName,
            value: item.reasonId

          }
        }
      ) : []
    setFollowupReason(followupReasonValue)
    const followupDateFormat = moment(followup.followupDate).format(
      "YYYY-MM-DD"
    )
    setIsEscalation(followup.isEscalation)
    const dateTimeLocal = moment(
      `${followupDateFormat} ${followup.time}`,
      "YYYY-MM-DDTHH:mm:ss A"
    ).format("YYYY-MM-DDTHH:mm")
    setFollowUpData({
      callDateAndTime: dateTimeLocal,
      personContacted: followup.personContacted,
      followUpRemarks: followup.followupRemarks,
    })
    setFutureFollowUpData({
      nextFollowUpDateAndTime: followup.futureFollowUpDate,
      remarks: followup.futureFollowupRemarks,
    })
    setCallType({ label: followup.callType, value: followup.callType })
    setInBoundType({ label: followup.inBoundType })
    setEscalationMode({ label: followup.modeOfEscalation })
    const followUpModevalue =
      !isEmpty(recordsMetaData) &&
      recordsMetaData.followUpModeOptions.find(
        (val) => val.value === followup.followupMode
      )?.label

    setFollowUpMode({
      label: followUpModevalue ? followUpModevalue.toString() : "",
      value: followup.followupMode,
    })
    const futureFollowUpModevalue =
      !isEmpty(recordsMetaData) &&
      recordsMetaData.followUpModeOptions.find(
        (val) => val.value === followup.futureModeOfFollowup
      )?.label
    setFutureFollowUpMode({
      label: futureFollowUpModevalue ? futureFollowUpModevalue.toString() : "",
      value: followup.futureModeOfFollowup,
    })
    const languageValue =
      followup.preferredLanguage?.map((lang) => {
        const languageOption =
          !isEmpty(recordsMetaData) &&
          recordsMetaData.languageOptions.find((data) => data.value === lang)
        return {
          label: languageOption ? languageOption.label.toString() : "",
          value: lang,
        }
      }) || []

    setPreferredLanguage(languageValue)
    setRadioOption({
      option: followup.reachStatus,
      checked: followup.reachStatus === "Completed" ? 0 : followup.reachStatus === "Not Completed" ? 1 : 2,
    })
    setFileLength(followup.attachment.length)
    setFileName(followup.attachment[0])
    // setFollowupId(followup._id)
    setUploadInput(followup.attachment)
    // setIsEdit(true)
    //  setECFollowupModal(true)
    setCriteriaDetails(followup.callCriteriaData)
    setActionsDetails(followup.actionData)
    const checkedIntroItemsId =
      followup.action &&
      followup.action.map((checkIntro) => {
        return {
          _id: checkIntro,
        }
      })
    setCheckedIntroItems(checkedIntroItemsId)

    const checkedItemsId =
      followup.callCriteria &&
      followup.callCriteria.map((check) => {
        return {
          _id: check,
        }
      })
    setCheckedItems(checkedItemsId)

    //deliverable status section
    const deliverStatusData =
      followup.deliverableStatusSectionData.length > 0
        ? followup.deliverableStatusSectionData.map((data) => {
          const applicableEvents =
            data && data.applicableEventsDetails.length > 0
              ? data.applicableEventsDetails
                .map((m) => m.eventName)
                .join(", ")
              : "--"
          const hintsId =
            data && data.hints.length > 0 ? data.hints.map((m) => m.id) : []
          const hintsName =
            data && data.hintsDetails.length > 0
              ? data.hintsDetails.map((m) => m.deliverableTag)
              : []
          const highlighted = data && data.hints.length > 0 ? data.hints.filter((m) => m.status == 2) : []
          const highlightedIds = !isEmpty(highlighted) ? highlighted.map(m => m.id) : []
          const tat = data.tatDate ? moment(data.tatDate) : ""
          const etaDate = tat
            ? tat.add(etaValue, "days").format(dateFormate)
            : ""
          return {
            _id: data._id,
            productId: data.product,
            productCategoryId: data.productCategoryId,
            productName: data.productName ? data.productName : "",
            applicableEvents: applicableEvents,
            quantity: data.quantity,
            deliverableStatus: data.deliverableStatus,
            tatDate: etaDate
              ? etaDate
              : "--",
            hintsId: hintsId,
            hintsName: hintsName,
            remarks: data.remarks,
            highlightedHints: highlightedIds
          }
        })
        : ""

    setDeliverableStatusSectionData(deliverStatusData)

    //issues update
    const issuesMapping = !isEmpty(followup.issuesData)
      ? followup.issuesData.map((data) => {
        const departmentName =
          data.departmentsData &&
          data.departmentsData.map((m) => m.name).toString()
        const empId = data.poc && data.poc.map((m) => m)
        const empName = empId.map((emp) => {
          const empLabel =
            !isEmpty(recordsMetaData) &&
            recordsMetaData.employeeOptions
              .find((lab) => lab.value === emp)
              .label.toString()
          return empLabel
        })


        return {
          departmentId: data.department,
          department: departmentName,
          issueDescription: data.issuesDescription,
          followUpCommentsId: "",
          followUpComments: data.internalFollowupComment,
          nextFollowUpDate: data.nextFollowupDate
            ? moment(data.nextFollowupDate).format("YYYY-MM-DD")
            : "",
          empId: empId,
          empName: empName,
          solutionOffered: data.solutionOffered,
          createdDate: data.createdAt,
          lastUpdatedDate: data.lastUpdatedDate,
          currentStatusName: data.currentStatus,
          currentStatusValue: data.currentStatus,
        }
      })
      : []

    setIssuesListData(issuesMapping)
    dispatch(ecFollowupAction.loadIssues({ leadId: id }))
  }
  const issuesListModalChange = async (e, index, name) => {

    var issuesList = [...issuesListData]

    if (
      name === "issueDescription" ||
      name === "nextFollowUpDate" ||
      name === "solutionOffered" ||
      name === "followUpComments"
    ) {
      issuesList[index][name] = e.target.value
    }
    if (name === "departmentId") {
      if (e) {
        issuesList[index]["departmentId"] = e.value
        issuesList[index]["department"] = e.label
      } else {
        issuesList[index]["departmentId"] = ""
        issuesList[index]["department"] = ""
      }
    }
    if (name === "currentStatusValue") {
      if (e) {
        issuesList[index]["currentStatusValue"] = e.value
        issuesList[index]["currentStatusName"] = e.label
      } else {
        issuesList[index]["currentStatusValue"] = ""
        issuesList[index]["currentStatusName"] = ""
      }
    }

    if (name === "empId") {
      const selectedOptions = Array.isArray(e) ? e : [e]
      const selectedValues = selectedOptions.map((option) => ({
        value: option.value,
        label: option.label,
      }))

      issuesList[index]["empId"] = selectedValues.map((option) => option.value)
      issuesList[index]["empName"] = selectedValues.map(
        (option) => option.label
      )
    }
    setIssuesListData(issuesList)
    setRenderPage(!renderPage)
  }
  const issuesUpdateData =
    !isEmpty(issuesListData) && issuesListData.length > 0
      ? issuesListData.map((data) => {
        if (data) {
          if (
            !isEmpty(data.departmentId) ||
            !isEmpty(data.issueDescription) ||
            !isEmpty(data.followUpComments) ||
            !isEmpty(data.nextFollowUpDate) ||
            !isEmpty(data.empId) ||
            !isEmpty(data.solutionOffered) ||
            !isEmpty(data.currentStatusValue)
          ) {
            const empId = data.empId && data.empId.map((m) => m)
            return {
              leadId: id,
              department: data.departmentId,
              issuesDescription: data.issueDescription,
              internalFollowupComment: data.followUpComments,
              nextFollowupDate: data.nextFollowUpDate
                ? moment(data.nextFollowUpDate).format("YYYY-MM-DD")
                : "",
              poc: empId,
              solutionOffered: data.solutionOffered,
              currentStatus: data.currentStatusValue,
            }
          }
        }
      }).filter(Boolean)
      : []
  const [validateUpdateDepartment, setValidateUpdateDepartment] =
    useState(false)

  const followupReasonUpdateValue = !isEmpty(followupReason) ?
    followupReason.map(
      (item) => {
        return {
          reasonName: item.label,
          reasonId: item.value

        }
      }
    ) : []
  //Update EC FOllowup
  const updateFollowup = () => {
    const callDateTime = moment(followUpData.callDateAndTime)
    const followupDate = moment(followUpData.callDateAndTime).format(
      "YYYY-MM-DD"
    )
    const time = callDateTime.format("h:mmA")
    const shouldValidateDepartment = issuesUpdateData.some((issue) => {
      return (
        isEmpty(issue.department) &&
        (!isEmpty(issue.issuesDescription) ||
          !isEmpty(issue.internalFollowupComment) ||
          !isEmpty(issue.nextFollowupDate) ||
          !isEmpty(issue.poc) ||
          !isEmpty(issue.solutionOffered) ||
          !isEmpty(issue.currentStatus))
      )
    })

    setValidateUpdateDepartment(shouldValidateDepartment)

    // Validate the form fields and conditionally check the department field
    const allValid = simpleValidator.current.allValid()
    var AttachmentValue = []
    if (uploadInput && uploadInput.length > 0) {
      uploadInput.map((data) => {
        AttachmentValue.push(data)
      })
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
    }
    const attachmentValidation =
      (!uploadInput || uploadInput.length === 0) &&
      (!mobileAttachmentSelected || mobileAttachmentSelected.length === 0)
    setAttachmentValidation(attachmentValidation)

    if (allValid && !shouldValidateDepartment && !attachmentValidation) {
      let updateFollowupData = {
        leadId: id,
        followupDate: followupDate,
        followupType: followUpModalDetails.value,
        time: time,
        followupMode: followUpMode.value,
        reachStatus: radioOption.option,
        followupRemarks: followUpData.followUpRemarks,
        attachment: AttachmentValue,
        personContacted: followUpData.personContacted,
        futureFollowupRemarks: futureFollowUpData.remarks,
        preferredLanguage: preferredLanguageValue,
        futureFollowUpDate: futureFollowUpData.nextFollowUpDateAndTime,
        futureModeOfFollowup: futureFollowUpMode.value,
        callCriteria: criteriaValue,
        action: actionValue,
        issues: issuesUpdateData.length > 0 ? issuesUpdateData : [],
        deliverableStateSection: deliverableSectionValue,
        isEscalation: isEscalation,
        ...(followupReasonUpdateValue && { followupReason: followupReasonUpdateValue })
      }

      specificDispatch(
        ecFollowupAction.updateOperationsFollowup(updateFollowupData)
      )
      setTimeout(() => {
        setIsEdit(false)
        toast.success("Records Updated Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setECFollowupModal(false)
        specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setECFollowupModal(true)
    }
  }
  /// update escalation
  const updateEscalationFollowup = () => {
    const callDateTime = moment(followUpData.callDateAndTime)
    const followupDate = moment(followUpData.callDateAndTime).format(
      "YYYY-MM-DD"
    )
    const time = callDateTime.format("h:mmA")
    const shouldValidateDepartment = issuesUpdateData.some((issue) => {
      return (
        isEmpty(issue.department) &&
        (!isEmpty(issue.issuesDescription) ||
          !isEmpty(issue.internalFollowupComment) ||
          !isEmpty(issue.nextFollowupDate) ||
          !isEmpty(issue.poc) ||
          !isEmpty(issue.solutionOffered) ||
          !isEmpty(issue.currentStatus))
      )
    })

    setValidateUpdateDepartment(shouldValidateDepartment)

    // Validate the form fields and conditionally check the department field
    const allValid = simpleEscalationValidator.current.allValid()
    var AttachmentValue = []
    if (uploadInput && uploadInput.length > 0) {
      uploadInput.map((data) => {
        AttachmentValue.push(data)
      })
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
    }
    const attachmentValidation =
      (!uploadInput || uploadInput.length === 0) &&
      (!mobileAttachmentSelected || mobileAttachmentSelected.length === 0)
    setAttachmentValidation(attachmentValidation)


    if (allValid && !shouldValidateDepartment && !attachmentValidation) {
      let updateFollowupData = {
        leadId: id,
        followupDate: followupDate,
        followupType: followUpModalDetails.value,
        time: time,
        followupMode: followUpMode.value,
        reachStatus: radioOption.option,
        modeOfEscalation: escalationMode.value,
        callType: callType.value,
        inBoundType: inBoundType.value,
        attachment: AttachmentValue,
        personContacted: followUpData.personContacted,
        preferredLanguage: preferredLanguageValue,
        futureFollowUpDate: futureFollowUpData.nextFollowUpDateAndTime,
        futureModeOfFollowup: futureFollowUpMode.value,
        futureFollowupRemarks: futureFollowUpData.remarks,
        // "callCriteria": criteriaValue,
        // "action": actionValue,
        issues: issuesUpdateData.length > 0 ? issuesUpdateData : [],
        deliverableStateSection: deliverableSectionValue,
        isEscalation: isEscalation,
        ...(followupReasonUpdateValue && { followupReason: followupReasonUpdateValue })
      }
      if (followUpModalDetails.value === "Escalation") {
        updateFollowupData.escalationRemarks = followUpData.followUpRemarks
      } else if (followUpModalDetails.value === "Followup") {
        updateFollowupData.followupRemarks = followUpData.followUpRemarks
      }

      specificDispatch(
        ecFollowupAction.updateOperationsFollowup(updateFollowupData)
      )
      setTimeout(() => {
        setIsEdit(false)
        toast.success("Records Updated Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setECFollowupModal(false)
        specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
      }, 1500)
    } else {
      simpleEscalationValidator.current.showMessages()
      escalateForceUpdate(1)
      setECFollowupModal(true)
    }
  }
  //update closure
  const updateClosureFollowup = () => {
    const callDateTime = moment(followUpData.callDateAndTime)
    const followupDate = moment(followUpData.callDateAndTime).format(
      "YYYY-MM-DD"
    )
    const time = callDateTime.format("h:mmA")
    const shouldValidateDepartment = issuesUpdateData.some((issue) => {
      return (
        isEmpty(issue.department) &&
        (!isEmpty(issue.issuesDescription) ||
          !isEmpty(issue.internalFollowupComment) ||
          !isEmpty(issue.nextFollowupDate) ||
          !isEmpty(issue.poc) ||
          !isEmpty(issue.solutionOffered) ||
          !isEmpty(issue.currentStatus))
      )
    })

    setValidateUpdateDepartment(shouldValidateDepartment)
    var AttachmentValue = []
    if (uploadInput && uploadInput.length > 0) {
      uploadInput.map((data) => {
        AttachmentValue.push(data)
      })
    } else if (
      mobileAttachmentSelected &&
      mobileAttachmentSelected.length > 0
    ) {
      mobileAttachmentSelected.map((data) => {
        AttachmentValue.push(data.attachment)
      })
    }
    const attachmentValidation =
      (!uploadInput || uploadInput.length === 0) &&
      (!mobileAttachmentSelected || mobileAttachmentSelected.length === 0)
    setAttachmentValidation(attachmentValidation)

    const allValid = simpleCloseValidator.current.allValid()
    if (allValid && !shouldValidateDepartment && !attachmentValidation) {
      let updateFollowupData = {
        leadId: id,
        followupDate: followupDate,
        followupType: followUpModalDetails.value,
        time: time,
        followupMode: followUpMode.value,
        reachStatus: radioOption.option,
        followupRemarks: followUpData.followUpRemarks,
        attachment: AttachmentValue,
        personContacted: followUpData.personContacted,
        preferredLanguage: preferredLanguageValue,
        futureFollowUpDate: futureFollowUpData.nextFollowUpDateAndTime,
        futureModeOfFollowup: futureFollowUpMode.value,
        futureFollowupRemarks: futureFollowUpData.remarks,
        action: actionValue,
        issues: issuesUpdateData.length > 0 ? issuesUpdateData : [],
        deliverableStateSection: deliverableSectionValue,
        isEscalation: isEscalation,
        ...(followupReasonUpdateValue && { followupReason: followupReasonUpdateValue })
      }

      specificDispatch(
        ecFollowupAction.updateOperationsFollowup(updateFollowupData)
      )
      setTimeout(() => {
        setIsEdit(false)
        toast.success("Records Updated Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setECFollowupModal(false)
        specificDispatch(ecFollowupAction.loadOperationsFollowup(id))
      }, 1500)
    } else {
      simpleCloseValidator.current.showMessages()
      closeForceUpdate(1)
      setECFollowupModal(true)
    }
  }

  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <p className="quote-head">
          Followup
          <span className="quote-info">
            <i
              style={{ color: "grey" }}
              id="DeliverablesInfoxyr"
              aria-hidden="true"
              className="fa fa-info-circle ms-1"
            ></i>
            <UncontrolledTooltip placement="right" target="DeliverablesInfoxyr">
              Followup
            </UncontrolledTooltip>
          </span>
        </p>
        <Col md="12" lg="12" xl="12">
          <Nav className="nav">
            {followUpButtons.map((data, index) => {
              return (
                <button
                  key={index}
                  type="submit"
                  className={data.color}
                  style={{
                    marginRight: "20px",
                    marginTop: "10px",
                  }}
                  onClick={() => {
                    setFollowUpTab(data.label)
                  }}
                >
                  {data.label}
                </button>
              )
            })}
          </Nav>
        </Col>
        {(() => {
          switch (followUpTab) {
            case "Operations Followup":
              return (
                <React.Fragment>
                  <Row className="quote-head-content">
                    <Col
                      lg="9"
                      md="9"
                      sm="6"
                      xs="6"
                      className="d-flex flex-row"
                    >
                      <p className="quote-head">
                        Operations Followup
                        <span className="quote-info">
                          <i
                            style={{ color: "grey" }}
                            id="quoteInfo1"
                            aria-hidden="true"
                            className="fa fa-info-circle ms-1"
                          ></i>
                          <UncontrolledTooltip
                            placement="right"
                            target="quoteInfo1"
                          >
                            Operations Followup
                          </UncontrolledTooltip>
                        </span>
                      </p>
                      {modeMenu === "EventComplete" ? (
                        ""
                      ) : (
                        <div className="d-flex flex-row">
                          <div
                            className="ec-followup-btn"
                            onClick={() => {
                              setDropDownModal(true)
                            }}
                          >
                            Add Followup
                          </div>
                          {!isEmpty(followUpModalDetails) && selectOpen ? (
                            <div style={{ marginLeft: "10px" }}>
                              <Input
                                type="text"
                                name="dropdownValue"
                                value={dropdownValue}
                                // onChange={(e) => setDropdownValue(e)}
                                disabled
                                className="w-100"
                                classNamePrefix="select2-selection"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-4">

                      <Input
                        type="textarea"
                        name="crmNotes"
                        value={crmNotesData.crmNotes}
                        onChange={(e) => handleCrmNotes(e)
                        }
                        placeholder="Enter Crm Notes"
                      />
                    </Col>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          onClick={() => updateCrm()}
                          className="btn btn-success"
                        >
                          Submit
                        </Button>
                      </div>
                    </Col>
                    <Col className="mt-3">
                      <Table bordered responsive>
                        <thead style={{ backgroundColor: "#f9f9f9" }}>
                          <tr>
                            <th>S.No</th>
                            <th>Action</th>
                            <th>Employee Id</th>
                            <th>Followup Type</th>
                            <th>Followup Date</th>
                            <th>Time</th>
                            <th>Mode</th>
                            <th>Reach Status</th>
                            <th>Followup Remarks</th>
                            <th>Future Followup Date</th>
                            <th>Attachment</th>
                            <th>Is Escalation</th>
                            <th>Followup Reason</th>
                            <th>Followup Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!isEmpty(followup_list) &&
                            followup_list.length > 0 ? (
                            followup_list.map((followup, index, arr) => {
                              var attachments = !isEmpty(followup.attachment)
                                ? followup.attachment.map((f) => f)
                                : []
                              const followUpModevalue =
                                !isEmpty(recordsMetaData) &&
                                recordsMetaData.followUpModeOptions.find(
                                  (val) => val.value === followup.followupMode
                                ).label
                              const followupReason = followup && !isEmpty(followup.followupReason) ?
                                followup.followupReason.map(m => m.reasonName).join(" ,") : "--"
                              return (
                                <>
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <button
                                        type="submit"
                                        className="btn btn-success"
                                        onClick={() => {
                                          editFollowup(followup)
                                          setIsEdit(true)
                                        }}
                                      >
                                        <i className="fas fa-edit"></i>
                                      </button>
                                    </td>
                                    <td>{followup.empName}</td>
                                    <td>
                                      {!isEmpty(followup) &&
                                        followup.followupType
                                        ? followup.followupType
                                        : ""}
                                    </td>
                                    <td>
                                      {!isEmpty(followup) &&
                                        followup.followupDate
                                        ? moment(followup.followupDate).format(
                                          "DD-MM-YYYY"
                                        )
                                        : ""}
                                    </td>
                                    <td>
                                      {!isEmpty(followup) && followup.time
                                        ? followup.time
                                        : ""}
                                    </td>
                                    <td>
                                      {followUpModevalue
                                        ? followUpModevalue.toString()
                                        : "--"}
                                    </td>
                                    <td>{followup.reachStatus}</td>
                                    <td>
                                      {!isEmpty(followup.followupRemarks)
                                        ? followup.followupRemarks
                                        : ""}
                                    </td>
                                    <td>
                                      {followup.futureFollowUpDate
                                        ? moment(
                                          followup.futureFollowUpDate
                                        ).format(dateFormate)
                                        : ""}
                                    </td>
                                    <td>
                                      <a
                                        onClick={() =>
                                          window.open(attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    </td>
                                    <td>{followup.isEscalation == true ? "YES" :
                                      followup.isEscalation == false ? "NO" : "--"}</td>
                                    <td>{followupReason}</td>
                                    <td>
                                      {<Button className=
                                        {followup.followupStatus == "CLOSED" ? "btn btn-danger" : "btn btn-success"}
                                        disabled={followup.followupStatus === "CLOSED" || arr.length === 1 || index == 0}
                                        onClick={() => {
                                          setFollowupStatusModal(true)
                                          setFollowupDetails(followup)
                                        }}>
                                        {followup.followupStatus}
                                      </Button>}
                                    </td>
                                  </tr>
                                </>
                              )
                            })
                          ) : (
                            <>
                              <tr key={0}>
                                <td colSpan={14} className="text-align-center">
                                  No record found
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                  {ecFollowupModal &&
                    (followUpModalDetails.value === "Intro Call" ? (
                      <>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Current Followup
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="quoteInfo12"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="quoteInfo12"
                                >
                                  Current Followup
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row
                          style={{ margin: "10px 0px" }}
                          className="d-flex flex-row ec-followup-form-content"
                        >
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Call Date & Time"}
                              >
                                {"Call Date & Time"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="datetime-local"
                              placeholder="Select Date"
                              name="callDateAndTime"
                              disabled
                              value={followUpData.callDateAndTime}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Mode Of Followup"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="followUpMode"
                              value={followUpMode}
                              onChange={(e) => setFollowUpMode(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpModeOptions
                                  : []
                              }
                              placeholder="Select Mode Of Followup"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "followUpMode",
                                followUpMode,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Reach Status"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <div className="d-flex flex-row">
                              {connectOptions.map((item, index) => {
                                return (
                                  <>
                                    <div className="form-check form-check-inline">
                                      <Input
                                        type="radio"
                                        key={item.id}
                                        name="Reach Status"
                                        value={radioOption.option}
                                        checked={radioOption.checked === index}
                                        onChange={(e) =>
                                          handleOptionsChange(e, index)
                                        }
                                      />

                                      <Label>{item.label}</Label>
                                    </div>
                                  </>
                                )
                              })}
                            </div>
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Reach Status",
                                radioOption.option,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                            <div className="d-flex flex-row">
                              {statusList.map((status, index) => {
                                return (
                                  <div className="d-flex flex-row" key={index}>
                                    <Input
                                      type="checkbox"
                                      name="isEscalation"
                                      value={status.value}
                                      checked={isEscalation === status.value}
                                      onChange={(e) =>
                                        handleStatusChange(e, status.value)
                                      }
                                      className="font-size-15"
                                    />
                                    <Label
                                      className="mx-2"
                                      style={{ marginTop: "2px", fontSize: "12px" }}
                                    >
                                      {status.label}
                                    </Label>
                                  </div>
                                )
                              })}
                            </div>
                          </Col>
                          <Col md="3" lg="3" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Contacted Person"}
                              >
                                {"Contacted Person"} {""}{" "}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter Person Contacted"
                              name="personContacted"
                              value={followUpData.personContacted}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "personContacted",
                                followUpData.personContacted,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Preferred Language"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="preferredLanguage"
                              isMulti
                              value={preferredLanguage}
                              onChange={(e) => setPreferredLanguage(e)}
                              options={recordsMetaData.languageOptions}
                              placeholder="Select Preferred Language"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "preferredLanguage",
                                preferredLanguage,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <Button className=" btn btn-warning  position-relative fs-5" onClick={() =>
                                  handleClickAttachment("desktop")
                                }>
                                  <i className="fas fa-laptop"></i>

                                  <input
                                    type="file"
                                    name="uploadInput"
                                    accept="application/pdf, audio/mp3 , image/jpeg"
                                    id="uploadAttachment"
                                    multiple
                                    onChange={(e) => uploadChange(e, renderPage)}
                                    style={{ display: "none" }}
                                    ref={inputDesktopAttachmentFile}
                                  />
                                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                    {fileLength ? fileLength : 0}
                                  </span>
                                </Button>
                              </div>
                              <div style={{ marginLeft: "40px" }}>
                                <Button
                                  className=" btn btn-info  position-relative fs-5"
                                  onClick={() =>
                                    handleClickAttachment("mobile")
                                  }
                                >
                                  <i className="fas fa-mobile-alt fs-3"></i>

                                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                    {mobileAttachmentSelected.length || 0}
                                  </span>
                                </Button>
                              </div>
                            </div>
                            <div className="text-decoration-underline text-danger">
                              {fileName ? fileName : ""}

                            </div>
                            {/* <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Attachment",
                                uploadInput,
                                "required"
                              )}
                            </div> */}
                            {attachmentValidation == true &&
                              (uploadInput.length == 0 &&
                                mobileAttachmentSelected.length == 0) ? (
                              <div className="srv-validation-message">
                                The Attachment field is required.
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>


                          <Col md="3" lg="3" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Followup Remarks"}
                              >
                                {"Followup Remarks"} {""}{" "}
                                {/* <span className="required">*</span> */}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Followup Remarks"
                              name="followUpRemarks"
                              value={followUpData.followUpRemarks}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            {/* <div style={{ textTransform: "capitalize" }}> */}
                            {/* {simpleValidator.current.message(
                              "Followup Remarks",
                              followUpData.followUpRemarks,
                              "required"
                            )}
                          </div> */}
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Followup Reason"}
                              </Label>
                            </div>
                            <Select
                              type="text"
                              isMulti
                              name="followupReason"
                              value={followupReason}
                              onChange={(e) => setFollowupReason(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followupReasonOptions
                                  : []
                              }
                              placeholder="Select Followup Reason"
                              classNamePrefix="select2-selection"
                            />

                          </Col>
                        </Row>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Future Followup
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="quoteInfo123"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="quoteInfo123"
                                >
                                  Future Followup
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row
                          style={{ margin: "10px 0px" }}
                          className="d-flex flex-row ec-followup-form-content"
                        >
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Next Followup  Date & Time"}
                              >
                                {"Next Followup Date & Time"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="datetime-local"
                              placeholder="Select Date"
                              name="nextFollowUpDateAndTime"
                              value={futureFollowUpData.nextFollowUpDateAndTime}
                              min={moment(futureFollowUpData.nextFollowUpDateAndTime).format('YYYY-MM-DDTHH:mm')}
                              max={moment(futureFollowUpData.nextFollowUpDateAndTime).add(13, 'days').format('YYYY-MM-DDTHH:mm')}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Mode Of Followup"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="futureFollowUpMode"
                              value={futureFollowUpMode}
                              onChange={(e) => setFutureFollowUpMode(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpModeOptions
                                  : []
                              }
                              placeholder="Select Mode Of Followup"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "futureFollowUpMode",
                                futureFollowUpMode,
                                "required"
                              )}
                            </div>
                          </Col>

                          <Col md="4" lg="4" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Contacted Person"}
                              >
                                {"Future Remarks"} {""}{" "}
                                {/* <span className="required">*</span> */}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Remarks"
                              name="remarks"
                              value={futureFollowUpData.remarks}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                            />
                            {/* <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Remarks",
                                futureFollowUpData.remarks,
                                "required"
                              )}
                            </div> */}
                          </Col>
                        </Row>

                        <Row>
                          <Col sm="8" xl="8" lg="8" className="mt-3">
                            <Table responsive striped>
                              <thead>
                                <tr>
                                  <th style={{ width: "70%" }}>
                                    Intro Call Criteria
                                  </th>
                                  <th style={{ width: "30%" }}>Yes/No</th>
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(criteriaDetails) ? (
                                  criteriaDetails.map((item, index) => (
                                    <tr key={index}>
                                      <td style={{ width: "70%" }}>
                                        {item.criteriaName}
                                      </td>
                                      <td style={{ width: "30%" }}>
                                        <Input
                                          type="checkbox"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                            marginLeft: "10px",
                                          }}
                                          checked={checkedItems.some(
                                            (checkedItem) =>
                                              checkedItem._id === item._id
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange(item)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <>
                                    <tr key={0}>
                                      <td
                                        colSpan={2}
                                        className="text-align-center"
                                      >
                                        No record found
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="8" xl="8" lg="8" className="mt-3">
                            <Table responsive striped>
                              <thead>
                                <tr>
                                  <th style={{ width: "70%" }}>
                                    Actions After Intro Call
                                  </th>
                                  <th style={{ width: "30%" }}>Yes/No</th>
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(actionsDetails) ? (
                                  actionsDetails.map((item, index) => (
                                    <tr key={index}>
                                      <td style={{ width: "70%" }}>
                                        {item.criteriaName}
                                      </td>
                                      <td style={{ width: "30%" }}>
                                        <Input
                                          type="checkbox"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                            marginLeft: "10px",
                                          }}
                                          checked={checkedIntroItems.some(
                                            (checkedItem) =>
                                              checkedItem._id === item._id
                                          )}
                                          onChange={() =>
                                            handleIntroCheckboxChange(item)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <>
                                    <tr key={0}>
                                      <td
                                        colSpan={2}
                                        className="text-align-center"
                                      >
                                        No record found
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Deliverable Status section
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="xy1"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="xy1"
                                >
                                  Deliverable Status section
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12" xl="12" lg="12" className="mt-3">
                            <Table responsive striped className="delTable1">
                              <thead>
                                <tr>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Product Name</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Applicable Events</th>
                                  <th style={{ minWidth: "50px", maxWidth: "80px" }}>Qty</th>
                                  <th style={{ minWidth: "120px", maxWidth: "120px" }}>Deliverable Status</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>TAT Date</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Hints Name</th>
                                  <th style={{ minWidth: "300px", maxWidth: "300px" }}>Hints</th> {/* Increased width */}
                                  <th style={{ minWidth: "300px", maxWidth: "300px" }}>Remarks</th> {/* Increased width */}
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(deliverableStatusSectionData) ? (
                                  deliverableStatusSectionData.map(
                                    (item, index) => {

                                      const hintsIdOptions = !isEmpty(hintsOptions) ? hintsOptions.filter(m => m.productCategoryId == item.productCategoryId) : []
                                      const hintsName = item.hintsId.length > 0
                                        ? item.hintsId.map((id, idx) => item.hintsName[idx]).join(", ")
                                        : "--"
                                      return (
                                        <tr key={index}>

                                          <td>
                                            {item.productName
                                              ? item.productName
                                              : "--"}
                                          </td>

                                          <td>{item.applicableEvents}</td>
                                          <td>{item.quantity}</td>
                                          <td>{item.deliverableStatus}</td>
                                          <td>
                                            {item.tatDate ? item.tatDate : "--"}
                                          </td>
                                          <td>{hintsName}</td>
                                          <td style={{ textAlign: "center" }}>

                                            <Select
                                              type="text"
                                              name="hintsId"
                                              isMulti
                                              value={
                                                item.hintsId.length > 0
                                                  ? item.hintsId.map(
                                                    (id, idx) => ({
                                                      value: id,
                                                      label:
                                                        item.hintsName[idx], // Assuming hintsName is also an array
                                                    })
                                                  )
                                                  : []
                                              }
                                              onChange={(e) =>
                                                modalChange(e, index, "hintsId")
                                              }
                                              placeholder="Select Hints"
                                              classNamePrefix="select2-selection"
                                              options={hintsIdOptions}
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                multiValue: (styles, { data }) => {
                                                  const isGrey = item.highlightedHints?.includes(data.value)
                                                  return {
                                                    ...styles,
                                                    backgroundColor: isGrey ? "grey" : "lightcoral",

                                                  }
                                                },
                                                multiValueLabel: (styles) => ({
                                                  ...styles,
                                                  color: "white",
                                                }),
                                                multiValueRemove: (styles, { data }) => ({
                                                  ...styles,
                                                  cursor: "pointer",
                                                  ":hover": {
                                                    backgroundColor: item.highlightedHints?.includes(data.value) ? "darkgrey" : "darkred",
                                                    color: "white",
                                                  },
                                                }),
                                              }}

                                            />
                                          </td>
                                          <td style={{ textAlign: "center", position: "relative", overflow: "visible" }}>
                                            <Input
                                              type="textarea"
                                              name="remarks"
                                              value={item.remarks}
                                              onChange={(e) =>
                                                modalChange(e, index, "remarks")
                                              }
                                              placeholder="Enter Remarks"
                                            />
                                          </td>
                                        </tr>
                                      )
                                    }
                                  )
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={8}
                                      className="text-align-center"
                                    >
                                      No Records Found..
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Issues
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="xy12"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="xy12"
                                >
                                  Issues
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                          {isEdit == false && (
                            <Col lg="3" md="3" sm="12">
                              <button
                                onClick={addIssues}
                                type="button"
                                className={"btn btn-info"}
                                style={{ float: "right" }}
                              >
                                Add More
                              </button>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col sm="12" xl="12" lg="12" className="mt-3">
                            {isEdit == false && (
                              <Table responsive striped>
                                <thead>
                                  <tr>
                                    <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                      Department{" "}
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Issue Description
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Internal Followup Comments
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Next Followup Date
                                    </th>
                                    <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                      POC (Emp Name)
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Solution Offered
                                    </th>
                                    <th>#</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {!isEmpty(issuesData) ? (
                                    issuesData.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td style={{ textAlign: "center" }}>
                                            <Select
                                              type="text"
                                              name="departmentId"
                                              value={
                                                item.departmentId
                                                  ? {
                                                    value: item.departmentId,
                                                    label: item.department,
                                                  }
                                                  : null
                                              }
                                              onChange={(e) => {
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "departmentId"
                                                )
                                              }}
                                              isClearable
                                              placeholder="Select Department"
                                              classNamePrefix="select2-selection"
                                              options={
                                                recordsMetaData.departmentOptions
                                              }
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                              }}
                                            />
                                            <div
                                              style={{
                                                fontSize: "10px",
                                                textAlign: "left",
                                              }}
                                            >
                                              {validateDepartment &&
                                                isEmpty(item.departmentId) && (
                                                  <p className="required">
                                                    Department Field Is Required
                                                  </p>
                                                )}
                                            </div>
                                          </td>

                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="text"
                                              name="issueDescription"
                                              value={item.issueDescription}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "issueDescription"
                                                )
                                              }
                                              placeholder="Enter Issue Description"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="text"
                                              name="followUpComments"
                                              value={item.followUpComments}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "followUpComments"
                                                )
                                              }
                                              placeholder="Enter Followup Comments"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="date"
                                              name="nextFollowUpDate"
                                              value={item.nextFollowUpDate}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "nextFollowUpDate"
                                                )
                                              }
                                              placeholder="Enter"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Select
                                              type="text"
                                              name="empId"
                                              isMulti
                                              value={
                                                item.empId.length > 0
                                                  ? item.empId.map(
                                                    (id, idx) => ({
                                                      value: id,
                                                      label:
                                                        item.empName[idx], // Assuming empName is also an array
                                                    })
                                                  )
                                                  : []
                                              }
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "empId"
                                                )
                                              }
                                              placeholder="Select Poc"
                                              classNamePrefix="select2-selection"
                                              options={
                                                recordsMetaData.employeeOptions
                                              }
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                              }}
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="test"
                                              name="solutionOffered"
                                              value={item.solutionOffered}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "solutionOffered"
                                                )
                                              }
                                              placeholder="Enter Solution Offered"
                                            />
                                          </td>

                                          <td>
                                            {" "}
                                            <i
                                              className="fa fa-times remove-icon"
                                              onClick={() =>
                                                removeIssuesdetails(index)
                                              }
                                            ></i>{" "}
                                          </td>
                                        </tr>
                                      )
                                    })
                                  ) : (
                                    <tr key={0}>
                                      <td
                                        colSpan={8}
                                        className="text-align-center"
                                      >
                                        No Records Found..
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            )}
                            {isEdit === true && (
                              <Col sm="12" xl="12" lg="12" className="mt-3">
                                <Table responsive striped>
                                  <thead>
                                    <tr>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        Department{" "}
                                      </th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        Issue Description
                                      </th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>Internal Followup Comments</th>
                                      <th>Next Followup Date</th>
                                      <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                        POC (Emp Name)
                                      </th>
                                      <th style={{ minWidth: "200px", maxWidth: "200px" }}>Solution Offered</th>
                                      <th style={{ minWidth: "200px", maxWidth: "200px" }}>Created Date</th>
                                      <th style={{ minWidth: "200px", maxWidth: "200px" }}>Last Updated Date</th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        Current Status
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {issuesListData &&
                                      issuesListData.length > 0 &&
                                      issuesListData.map((item, index) => {
                                        return (
                                          <tr key={index}>
                                            <td style={{ textAlign: "center" }}>
                                              <Select
                                                type="text"
                                                name="departmentId"
                                                value={
                                                  item.departmentId
                                                    ? {
                                                      value:
                                                        item.departmentId,
                                                      label: item.department,
                                                    }
                                                    : { value: "", label: "" }
                                                }
                                                isClearable
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "departmentId"
                                                  )
                                                }
                                                placeholder="Select Department"
                                                classNamePrefix="select2-selection"
                                                options={
                                                  recordsMetaData.departmentOptions
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                              <div
                                                style={{
                                                  fontSize: "10px",
                                                  textAlign: "left",
                                                }}
                                              >
                                                {validateUpdateDepartment &&
                                                  isEmpty(
                                                    item.departmentId
                                                  ) && (
                                                    <p className="required">
                                                      Department Field Is
                                                      Required
                                                    </p>
                                                  )}
                                              </div>
                                            </td>

                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="issueDescription"
                                                value={item.issueDescription}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "issueDescription"
                                                  )
                                                }
                                                placeholder="Enter Issue Description"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="followUpComments"
                                                value={item.followUpComments}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "followUpComments"
                                                  )
                                                }
                                                placeholder="Enter Followup Comments"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="date"
                                                name="nextFollowUpDate"
                                                value={item.nextFollowUpDate}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "nextFollowUpDate"
                                                  )
                                                }
                                                placeholder="Enter"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Select
                                                type="text"
                                                name="empId"
                                                isMulti
                                                value={
                                                  item.empId.length > 0
                                                    ? item.empId.map(
                                                      (id, idx) => ({
                                                        value: id,
                                                        label:
                                                          item.empName[idx],
                                                      })
                                                    )
                                                    : []
                                                }
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "empId"
                                                  )
                                                }
                                                placeholder="Select Poc"
                                                classNamePrefix="select2-selection"
                                                options={
                                                  recordsMetaData.employeeOptions
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                              {/* <Select

                                    type="text"
                                    name="empId"
                                    isMulti
                                    value={
                                      item.empId
                                        ? {
                                          value: item.empId,
                                          label: item.empName
                                        }
                                        : ""
                                    }
                                    onChange={(e) =>
                                      issuesListModalChange(e, index, "empId")
                                    }
                                    placeholder="Select Poc"
                                    classNamePrefix="select2-selection"
                                    options={recordsMetaData.employeeOptions}
                                  /> */}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="solutionOffered"
                                                value={item.solutionOffered}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "solutionOffered"
                                                  )
                                                }
                                                placeholder="Enter Solution Offered"
                                              />
                                            </td>
                                            <td>
                                              {item.createdDate
                                                ? moment(
                                                  item.createdDate
                                                ).format(dateFormate)
                                                : ""}
                                            </td>
                                            <td>{item.lastUpdatedDate}</td>
                                            <td>
                                              <Select
                                                type="text"
                                                name="currentStatusValue"
                                                value={
                                                  item.currentStatusValue
                                                    ? {
                                                      value:
                                                        item.currentStatusValue,
                                                      label:
                                                        item.currentStatusName,
                                                    }
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "currentStatusValue"
                                                  )
                                                }
                                                placeholder="Select"
                                                classNamePrefix="select2-selection"
                                                options={[
                                                  {
                                                    label: "Pending",
                                                    value: "Pending",
                                                  },
                                                  {
                                                    label: "Resolved",
                                                    value: "Resolved",
                                                  },
                                                ]}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                            </td>
                                          </tr>
                                        )
                                      })}
                                  </tbody>
                                </Table>
                              </Col>
                            )}
                            {/* Issue's data table list */}
                            <Col sm="12" xl="12" lg="12" className="mt-3">
                              <Table responsive striped>
                                <thead>
                                  <tr>
                                    <th style={{ width: "10%" }}>
                                      Department{" "}
                                    </th>
                                    <th style={{ minWidth: "150px" }}>
                                      Issue Description
                                    </th>
                                    <th style={{ minWidth: "217px" }}>
                                      Internal Followup Comments
                                    </th>
                                    <th style={{ minWidth: "154px" }}>
                                      Next Followup Date
                                    </th>
                                    <th style={{ minWidth: "145px" }}>
                                      POC (Emp Name)
                                    </th>
                                    <th style={{ minWidth: "134px" }}>
                                      Solution Offered
                                    </th>
                                    <th style={{ minWidth: "116px" }}>
                                      Created Date
                                    </th>
                                    <th style={{ minWidth: "154px" }}>
                                      Last Updated Date
                                    </th>
                                    <th style={{ minWidth: "140px" }}>
                                      Current Status
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {issuesExistingTable &&
                                    issuesExistingTable.length > 0 ? (
                                    issuesExistingTable.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td style={{ textAlign: "center" }}>
                                            {item.department}
                                          </td>

                                          <td style={{ textAlign: "center" }}>
                                            {item.issueDescription}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.followUpComments}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.nextFollowUpDate}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.empName}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.solutionOffered}
                                          </td>
                                          <td>{item.createdDate}</td>
                                          <td>{item.lastUpdatedDate}</td>
                                          <td>{item.currentStatusValue}</td>
                                        </tr>
                                      )
                                    })
                                  ) : (
                                    <tr key={0}>
                                      <td
                                        style={{ textAlign: "center" }}
                                        colSpan={9}
                                      >
                                        No records found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </Col>
                          </Col>

                          <Col md="12" xl="12" lg="12" className="mt-5 mb-3">
                            <div
                              style={{ float: "right" }}
                              className="d-flex flex-row"
                            >
                              <Button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => {
                                  setECFollowupModal(false)
                                  clearFollowupModal()
                                  // resetDeliverableStatusSectionData()
                                }}
                              >
                                Cancel
                              </Button>
                              {isEdit ? (
                                <Button
                                  type="button"
                                  variant="primary"
                                  className="btn btn-success mx-2"
                                  onClick={() => {
                                    updateFollowup()
                                  }}
                                >
                                  Update
                                </Button>
                              ) : (
                                <Button
                                  type="button"
                                  variant="primary"
                                  className="btn btn-success mx-2"
                                  onClick={(e) => {
                                    addFollowup(e)
                                  }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </>
                    ) : followUpModalDetails.value === "Followup" ||
                      followUpModalDetails.value === "Escalation" ? (
                      <>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Current Followup
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="quoteInfo12"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="quoteInfo12"
                                >
                                  Current Followup
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row
                          style={{ margin: "10px 0px" }}
                          className="d-flex flex-row ec-followup-form-content"
                        >
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Call Date & Time"}
                              >
                                {"Call Date & Time"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="datetime-local"
                              placeholder="Select Date"
                              disabled
                              name="callDateAndTime"
                              value={followUpData.callDateAndTime}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Mode Of Followup"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="followUpMode"
                              value={followUpMode}
                              onChange={(e) => setFollowUpMode(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpModeOptions
                                  : []
                              }
                              placeholder="Select Mode Of Followup"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleEscalationValidator.current.message(
                                "followUpMode",
                                followUpMode,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Reach Status"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <div className="d-flex flex-row">
                              {connectOptions.map((item, index) => {
                                return (
                                  <>
                                    <div className="form-check form-check-inline">
                                      <Input
                                        type="radio"
                                        key={item.id}
                                        name="Reach Status"
                                        value={radioOption.option}
                                        checked={radioOption.checked === index}
                                        onChange={(e) =>
                                          handleOptionsChange(e, index)
                                        }
                                      />

                                      <Label>{item.label}</Label>
                                    </div>
                                  </>
                                )
                              })}
                            </div>
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleEscalationValidator.current.message(
                                "Reach Status",
                                radioOption.option,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                            <div className="d-flex flex-row">
                              {statusList.map((status, index) => {
                                return (
                                  <div className="d-flex flex-row" key={index}>
                                    <Input
                                      type="checkbox"
                                      name="isEscalation"
                                      value={status.value}
                                      checked={isEscalation === status.value}
                                      onChange={(e) =>
                                        handleStatusChange(e, status.value)
                                      }
                                      className="font-size-15"
                                    />
                                    <Label
                                      className="mx-2"
                                      style={{ marginTop: "2px", fontSize: "12px" }}
                                    >
                                      {status.label}
                                    </Label>
                                  </div>
                                )
                              })}
                            </div>
                          </Col>
                          {followUpModalDetails.value === "Escalation" && (
                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                              <div className="d-flex justify-content-between">
                                <Label className={"form-label"}>
                                  {"Mode Of Escalation"}
                                </Label>
                              </div>
                              <Select
                                type="text"
                                name="escalationMode"
                                value={escalationMode}
                                onChange={(e) => setEscalationMode(e)}
                                options={escalationModeOptions}
                                placeholder="Select Mode Of Escalation"
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                          )}
                          <Col md="3" lg="3" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Contacted Person"}
                              >
                                {"Contacted Person"} {""}{" "}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter Person Contacted"
                              name="personContacted"
                              value={followUpData.personContacted}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleEscalationValidator.current.message(
                                "personContacted",
                                followUpData.personContacted,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Call Type"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="callType"
                              value={callType}
                              onChange={(e) => setCallType(e)}
                              options={callTypeOptions}
                              placeholder="Select Call Type"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleEscalationValidator.current.message(
                                "callType",
                                callType,
                                "required"
                              )}
                            </div>
                          </Col>
                          {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            <Label className={"form-label"}>
                              {"Preferred Language"}
                              <span className="required">*</span>
                            </Label>
                          </div>
                          <Select
                            type="text"
                            name="preferredLanguage"
                            value={preferredLanguage}
                            isMulti
                            onChange={(e) => setPreferredLanguage(e)}
                            options={recordsMetaData.languageOptions}
                            placeholder="Select Preferred Language"
                            classNamePrefix="select2-selection"
                          />
                          <div style={{ textTransform: "capitalize" }}>
                            {simpleEscalationValidator.current.message(
                              "preferredLanguage",
                              preferredLanguage,
                              "required"
                            )}
                          </div>
                        </Col> */}
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <Button className=" btn btn-warning  position-relative fs-5" onClick={() =>
                                  handleClickAttachment("desktop")
                                }>
                                  <i className="fas fa-laptop"></i>

                                  <input
                                    type="file"
                                    name="uploadInput"
                                    accept="application/pdf, audio/mp3 , image/jpeg"
                                    id="uploadAttachment"
                                    multiple
                                    onChange={(e) => uploadChange(e, renderPage)}
                                    style={{ display: "none" }}
                                    ref={inputDesktopAttachmentFile}
                                  />
                                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                    {fileLength ? fileLength : 0}
                                  </span>
                                </Button>
                              </div>
                              <div style={{ marginLeft: "40px" }}>
                                <Button
                                  className=" btn btn-info  position-relative fs-5"
                                  onClick={() =>
                                    handleClickAttachment("mobile")
                                  }
                                >
                                  <i className="fas fa-mobile-alt fs-3"></i>

                                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                    {mobileAttachmentSelected.length || 0}
                                  </span>
                                </Button>
                              </div>
                            </div>
                            <div className="text-decoration-underline text-danger">
                              {fileName ? fileName : ""}

                            </div>
                            {/* <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Attachment",
                                uploadInput,
                                "required"
                              )}
                            </div> */}
                            {attachmentValidation == true &&
                              (uploadInput.length == 0 &&
                                mobileAttachmentSelected.length == 0) ? (
                              <div className="srv-validation-message">
                                The Attachment field is required.
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col md="3" lg="3" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Contacted Person"}
                              >
                                {followUpModalDetails.value === "Escalation"
                                  ? "Escalation Remarks"
                                  : "Followup Remarks"}{" "}
                                {/* {""} <span className="required">*</span> */}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Followup Remarks"
                              name="followUpRemarks"
                              value={followUpData.followUpRemarks}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            {/* <div style={{ textTransform: "capitalize" }}>
                              {simpleEscalationValidator.current.message(
                                "Followup Remarks",
                                followUpData.followUpRemarks,
                                "required"
                              )}
                            </div> */}
                          </Col>
                          {callType.value == "Inbound" && (
                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                              <div className="d-flex justify-content-between">
                                <Label className={"form-label"}>
                                  {"InBound Type"}
                                  <span className="required">*</span>
                                </Label>
                              </div>
                              <Select
                                type="text"
                                name="inBoundType"
                                value={inBoundType}
                                onChange={(e) => setInBoundType(e)}
                                options={inBoundTypeOptions}
                                placeholder="Select Inbound Type"
                                classNamePrefix="select2-selection"
                              />
                            </Col>

                          )}
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Followup Reason"}
                              </Label>
                            </div>
                            <Select
                              type="text"
                              isMulti
                              name="followupReason"
                              value={followupReason}
                              onChange={(e) => setFollowupReason(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followupReasonOptions
                                  : []
                              }
                              placeholder="Select Followup Reason"
                              classNamePrefix="select2-selection"
                            />

                          </Col>
                        </Row>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Future Followup
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="quoteInfo123"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="quoteInfo123"
                                >
                                  Future Followup
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row
                          style={{ margin: "10px 0px" }}
                          className="d-flex flex-row ec-followup-form-content"
                        >
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Next Followup  Date & Time"}
                              >
                                {"Next Followup Date & Time"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="datetime-local"
                              placeholder="Select Date"
                              name="nextFollowUpDateAndTime"
                              value={futureFollowUpData.nextFollowUpDateAndTime}
                              min={moment(futureFollowUpData.nextFollowUpDateAndTime).format('YYYY-MM-DDTHH:mm')}
                              max={moment(futureFollowUpData.nextFollowUpDateAndTime).add(13, 'days').format('YYYY-MM-DDTHH:mm')}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Mode Of Followup"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="futureFollowUpMode"
                              value={futureFollowUpMode}
                              onChange={(e) => setFutureFollowUpMode(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpModeOptions
                                  : []
                              }
                              placeholder="Select Mode Of Followup"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleEscalationValidator.current.message(
                                "futureFollowUpMode",
                                futureFollowUpMode,
                                "required"
                              )}
                            </div>
                          </Col>

                          <Col md="4" lg="4" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Contacted Person"}
                              >
                                {"Future Remarks"} {""}{" "}
                                {/* <span className="required">*</span> */}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Remarks"
                              name="remarks"
                              value={futureFollowUpData.remarks}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                            />
                            {/* <div style={{ textTransform: "capitalize" }}>
                              {simpleEscalationValidator.current.message(
                                "Remarks",
                                futureFollowUpData.remarks,
                                "required"
                              )}
                            </div> */}
                          </Col>
                        </Row>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Deliverable Status section
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="xy1"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="xy1"
                                >
                                  Deliverable Status section
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12" xl="12" lg="12" className="mt-3">
                            <Table responsive striped>
                              <thead>
                                <tr>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Product Name</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Applicable Events</th>
                                  <th style={{ minWidth: "50px", maxWidth: "80px" }}>Qty</th>
                                  <th style={{ minWidth: "120px", maxWidth: "120px" }}>Deliverable Status</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>TAT Date</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Hints Name</th>
                                  <th style={{ minWidth: "300px", maxWidth: "300px" }}>Hints</th> {/* Increased width */}
                                  <th style={{ minWidth: "300px", maxWidth: "300px" }}>Remarks</th> {/* Increased width */}
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(deliverableStatusSectionData) ? (
                                  deliverableStatusSectionData.map(
                                    (item, index) => {
                                      const hintsName = item.hintsId.length > 0
                                        ? item.hintsId.map((id, idx) => item.hintsName[idx])
                                        : "--"
                                      const hintsIdOptions = !isEmpty(hintsOptions) ? hintsOptions.filter(m => m.productCategoryId == item.productCategoryId) : []
                                      return (
                                        <tr key={index}>

                                          <td>
                                            {item.productName
                                              ? item.productName
                                              : "--"}
                                          </td>

                                          <td>{item.applicableEvents}</td>
                                          <td>{item.quantity}</td>
                                          <td>{item.deliverableStatus}</td>
                                          <td>
                                            {item.tatDate ? item.tatDate : "--"}
                                          </td>
                                          <td>{hintsName}</td>
                                          <td style={{ textAlign: "center" }}>
                                            {/* <Select
                                            type="text"
                                            name="hintsId"
                                            isMulti
                                            value={
                                              item.hintsId
                                                ? {
                                                  value: item.hintsId,
                                                  label: item.hintsName,
                                                }
                                                : { value: "", label: "Select" }
                                            }
                                            options={hintsOptions}
            
                                            onChange={(e) =>
                                              modalChange(e, index, "hintsId")
                                            }
                                            placeholder="Select Status"
                                            classNamePrefix="select2-selection"
                                          /> */}
                                            <Select
                                              type="text"
                                              name="hintsId"
                                              isMulti
                                              value={
                                                item.hintsId.length > 0
                                                  ? item.hintsId.map(
                                                    (id, idx) => ({
                                                      value: id,
                                                      label:
                                                        item.hintsName[idx], // Assuming hintsName is also an array
                                                    })
                                                  )
                                                  : []
                                              }
                                              onChange={(e) =>
                                                modalChange(e, index, "hintsId")
                                              }
                                              placeholder="Select Hints"
                                              classNamePrefix="select2-selection"
                                              options={hintsIdOptions}
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                multiValue: (styles, { data }) => {
                                                  const isGrey = item.highlightedHints?.includes(data.value)
                                                  return {
                                                    ...styles,
                                                    backgroundColor: isGrey ? "grey" : "lightcoral",

                                                  }
                                                },
                                                multiValueLabel: (styles) => ({
                                                  ...styles,
                                                  color: "white",
                                                }),
                                                multiValueRemove: (styles, { data }) => ({
                                                  ...styles,
                                                  cursor: "pointer",
                                                  ":hover": {
                                                    backgroundColor: item.highlightedHints?.includes(data.value) ? "darkgrey" : "darkred",
                                                    color: "white",
                                                  },
                                                }),
                                              }}
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="textarea"
                                              name="remarks"
                                              value={item.remarks}
                                              onChange={(e) =>
                                                modalChange(e, index, "remarks")
                                              }
                                              placeholder="Enter Remarks"
                                            />
                                          </td>
                                        </tr>
                                      )
                                    }
                                  )
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={8}
                                      className="text-align-center"
                                    >
                                      No Records Found..
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>

                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Issues
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="xy12"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="xy12"
                                >
                                  Issues
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                          {isEdit == false && (
                            <Col lg="3" md="3" sm="12">
                              <button
                                onClick={addIssues}
                                type="button"
                                className={"btn btn-info"}
                                style={{ float: "right" }}
                              >
                                Add More
                              </button>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col sm="12" xl="12" lg="12" className="mt-3">
                            {isEdit == false && (
                              <Table responsive striped>
                                <thead>
                                  <tr>
                                    <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                      Department{" "}
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Issue Description
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Internal Followup Comments
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Next Followup Date
                                    </th>
                                    <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                      POC (Emp Name)
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Solution Offered
                                    </th>
                                    <th>#</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {!isEmpty(issuesData) ? (
                                    issuesData.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td style={{ textAlign: "center" }}>
                                            <Select
                                              type="text"
                                              name="departmentId"
                                              value={
                                                item.departmentId
                                                  ? {
                                                    value: item.departmentId,
                                                    label: item.department,
                                                  }
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "departmentId"
                                                )
                                              }
                                              isClearable
                                              placeholder="Select Department"
                                              classNamePrefix="select2-selection"
                                              options={
                                                recordsMetaData.departmentOptions
                                              }
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                              }}
                                            />
                                            <div
                                              style={{
                                                fontSize: "10px",
                                                textAlign: "left",
                                              }}
                                            >
                                              {validateDepartment &&
                                                isEmpty(item.departmentId) && (
                                                  <p className="required">
                                                    Department Field Is Required
                                                  </p>
                                                )}
                                            </div>
                                          </td>

                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="text"
                                              name="issueDescription"
                                              value={item.issueDescription}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "issueDescription"
                                                )
                                              }
                                              placeholder="Enter Issue Description"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="text"
                                              name="followUpComments"
                                              value={item.followUpComments}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "followUpComments"
                                                )
                                              }
                                              placeholder="Enter Followup Comments"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="date"
                                              name="nextFollowUpDate"
                                              value={item.nextFollowUpDate}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "nextFollowUpDate"
                                                )
                                              }
                                              placeholder="Enter"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Select
                                              type="text"
                                              name="empId"
                                              isMulti
                                              value={
                                                item.empId.length > 0
                                                  ? item.empId.map(
                                                    (id, idx) => ({
                                                      value: id,
                                                      label:
                                                        item.empName[idx], // Assuming empName is also an array
                                                    })
                                                  )
                                                  : []
                                              }
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "empId"
                                                )
                                              }
                                              placeholder="Select Poc"
                                              classNamePrefix="select2-selection"
                                              options={
                                                recordsMetaData.employeeOptions
                                              }
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                              }}
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="test"
                                              name="solutionOffered"
                                              value={item.solutionOffered}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "solutionOffered"
                                                )
                                              }
                                              placeholder="Enter Solution Offered"
                                            />
                                          </td>

                                          <td>
                                            {" "}
                                            <i
                                              className="fa fa-times remove-icon"
                                              onClick={() =>
                                                removeIssuesdetails(index)
                                              }
                                            ></i>{" "}
                                          </td>
                                        </tr>
                                      )
                                    })
                                  ) : (
                                    <tr key={0}>
                                      <td
                                        colSpan={8}
                                        className="text-align-center"
                                      >
                                        No Records Found..
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            )}
                            {isEdit === true && (
                              <Col sm="12" xl="12" lg="12" className="mt-3">
                                <Table striped responsive>
                                  <thead>
                                    <tr>
                                      <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                        Department{" "}
                                      </th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        Issue Description
                                      </th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>Internal Followup Comments</th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>Next Followup Date</th>
                                      <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                        POC (Emp Name)
                                      </th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>Solution Offered</th>
                                      <th style={{ minWidth: "150px", maxWidth: "150px" }}>Created Date</th>
                                      <th style={{ minWidth: "150px", maxWidth: "150px" }}>Last Updated Date</th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        Current Status
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {issuesListData &&
                                      issuesListData.length > 0 &&
                                      issuesListData.map((item, index) => {
                                        return (
                                          <tr key={index}>
                                            <td style={{ textAlign: "center" }}>
                                              <Select
                                                type="text"
                                                name="departmentId"
                                                value={
                                                  item.departmentId
                                                    ? {
                                                      value:
                                                        item.departmentId,
                                                      label: item.department,
                                                    }
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "departmentId"
                                                  )
                                                }
                                                isClearable
                                                placeholder="Select Department"
                                                classNamePrefix="select2-selection"
                                                options={
                                                  recordsMetaData.departmentOptions
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                              <div
                                                style={{
                                                  fontSize: "10px",
                                                  textAlign: "left",
                                                }}
                                              >
                                                {validateUpdateDepartment &&
                                                  isEmpty(
                                                    item.departmentId
                                                  ) && (
                                                    <p className="required">
                                                      Department Field Is
                                                      Required
                                                    </p>
                                                  )}
                                              </div>
                                            </td>

                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="issueDescription"
                                                value={item.issueDescription}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "issueDescription"
                                                  )
                                                }
                                                placeholder="Enter Issue Description"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="followUpComments"
                                                value={item.followUpComments}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "followUpComments"
                                                  )
                                                }
                                                placeholder="Enter Followup Comments"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="date"
                                                name="nextFollowUpDate"
                                                value={item.nextFollowUpDate}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "nextFollowUpDate"
                                                  )
                                                }
                                                placeholder="Enter"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Select
                                                type="text"
                                                name="empId"
                                                isMulti
                                                value={
                                                  item.empId.length > 0
                                                    ? item.empId.map(
                                                      (id, idx) => ({
                                                        value: id,
                                                        label:
                                                          item.empName[idx],
                                                      })
                                                    )
                                                    : []
                                                }
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "empId"
                                                  )
                                                }
                                                placeholder="Select Poc"
                                                classNamePrefix="select2-selection"
                                                options={
                                                  recordsMetaData.employeeOptions
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                              {/* <Select

                                    type="text"
                                    name="empId"
                                    isMulti
                                    value={
                                      item.empId
                                        ? {
                                          value: item.empId,
                                          label: item.empName
                                        }
                                        : ""
                                    }
                                    onChange={(e) =>
                                      issuesListModalChange(e, index, "empId")
                                    }
                                    placeholder="Select Poc"
                                    classNamePrefix="select2-selection"
                                    options={recordsMetaData.employeeOptions}
                                  /> */}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="solutionOffered"
                                                value={item.solutionOffered}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "solutionOffered"
                                                  )
                                                }
                                                placeholder="Enter Solution Offered"
                                              />
                                            </td>
                                            <td>
                                              {item.createdDate
                                                ? moment(
                                                  item.createdDate
                                                ).format(dateFormate)
                                                : ""}
                                            </td>
                                            <td>{item.lastUpdatedDate}</td>
                                            <td>
                                              <Select
                                                type="text"
                                                name="currentStatusValue"
                                                value={
                                                  item.currentStatusValue
                                                    ? {
                                                      value:
                                                        item.currentStatusValue,
                                                      label:
                                                        item.currentStatusName,
                                                    }
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "currentStatusValue"
                                                  )
                                                }
                                                placeholder="Select"
                                                classNamePrefix="select2-selection"
                                                options={[
                                                  {
                                                    label: "Pending",
                                                    value: "Pending",
                                                  },
                                                  {
                                                    label: "Resolved",
                                                    value: "Resolved",
                                                  },
                                                ]}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                            </td>
                                          </tr>
                                        )
                                      })}
                                  </tbody>
                                </Table>
                              </Col>
                            )}
                          </Col>
                          {/* Issue's data table list */}
                          <Col sm="12" xl="12" lg="12" className="mt-3">
                            <Table responsive striped>
                              <thead>
                                <tr>
                                  <th style={{ width: "10%" }}>Department </th>
                                  <th style={{ minWidth: "150px" }}>
                                    Issue Description
                                  </th>
                                  <th style={{ minWidth: "217px" }}>
                                    Internal Followup Comments
                                  </th>
                                  <th style={{ minWidth: "154px" }}>
                                    Next Followup Date
                                  </th>
                                  <th style={{ minWidth: "145px" }}>
                                    POC (Emp Name)
                                  </th>
                                  <th style={{ minWidth: "134px" }}>
                                    Solution Offered
                                  </th>
                                  <th style={{ minWidth: "116px" }}>
                                    Created Date
                                  </th>
                                  <th style={{ minWidth: "154px" }}>
                                    Last Updated Date
                                  </th>
                                  <th style={{ minWidth: "140px" }}>
                                    Current Status
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {issuesExistingTable &&
                                  issuesExistingTable.length > 0 ? (
                                  issuesExistingTable.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td style={{ textAlign: "center" }}>
                                          {item.department}
                                        </td>

                                        <td style={{ textAlign: "center" }}>
                                          {item.issueDescription}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          {item.followUpComments}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          {item.nextFollowUpDate}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          {item.empName}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          {item.solutionOffered}
                                        </td>
                                        <td>{item.createdDate}</td>
                                        <td>{item.lastUpdatedDate}</td>
                                        <td>{item.currentStatusValue}</td>
                                      </tr>
                                    )
                                  })
                                ) : (
                                  <tr key={0}>
                                    <td
                                      style={{ textAlign: "center" }}
                                      colSpan={9}
                                    >
                                      No records found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                          <Col md="12" xl="12" lg="12" className="mt-5 mb-3">
                            <div
                              style={{ float: "right" }}
                              className="d-flex flex-row"
                            >
                              <Button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => {
                                  setECFollowupModal(false)
                                  clearFollowupModal()
                                  // resetDeliverableStatusSectionData()
                                }}
                              >
                                Cancel
                              </Button>
                              {isEdit ? (
                                <Button
                                  type="button"
                                  variant="primary"
                                  className="btn btn-success mx-2"
                                  onClick={() => {
                                    updateEscalationFollowup()
                                  }}
                                >
                                  Update
                                </Button>
                              ) : (
                                <Button
                                  type="button"
                                  variant="primary"
                                  className="btn btn-success mx-2"
                                  onClick={(e) => {
                                    addEscalation(e)
                                  }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </>
                    ) : followUpModalDetails.value === "Closure Call" ? (
                      <>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Current Followup
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="quoteInfo12"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="quoteInfo12"
                                >
                                  Current Followup
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row
                          style={{ margin: "10px 0px" }}
                          className="d-flex flex-row ec-followup-form-content"
                        >
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Call Date & Time"}
                              >
                                {"Call Date & Time"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="datetime-local"
                              placeholder="Select Date"
                              disabled
                              name="callDateAndTime"
                              value={followUpData.callDateAndTime || currentDateTimeMoment}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Mode Of Followup"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="followUpMode"
                              value={followUpMode}
                              onChange={(e) => setFollowUpMode(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpModeOptions
                                  : []
                              }
                              placeholder="Select Mode Of Followup"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleCloseValidator.current.message(
                                "followUpMode",
                                followUpMode,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Reach Status"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <div className="d-flex flex-row">
                              {connectOptions.map((item, index) => {
                                return (
                                  <>
                                    <div className="form-check form-check-inline">
                                      <Input
                                        type="radio"
                                        key={item.id}
                                        name="Reach Status"
                                        value={radioOption.option}
                                        checked={radioOption.checked === index}
                                        onChange={(e) =>
                                          handleOptionsChange(e, index)
                                        }
                                      />

                                      <Label>{item.label}</Label>
                                    </div>
                                  </>
                                )
                              })}
                            </div>
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleCloseValidator.current.message(
                                "Reach Status",
                                radioOption.option,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                            <div className="d-flex flex-row">
                              {statusList.map((status, index) => {
                                return (
                                  <div className="d-flex flex-row" key={index}>
                                    <Input
                                      type="checkbox"
                                      name="isEscalation"
                                      value={status.value}
                                      checked={isEscalation === status.value}
                                      onChange={(e) =>
                                        handleStatusChange(e, status.value)
                                      }
                                      className="font-size-15"
                                    />
                                    <Label
                                      className="mx-2"
                                      style={{ marginTop: "2px", fontSize: "12px" }}
                                    >
                                      {status.label}
                                    </Label>
                                  </div>
                                )
                              })}
                            </div>
                          </Col>
                          <Col md="3" lg="3" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Contacted Person"}
                              >
                                {"Contacted Person"} {""}{" "}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="text"
                              placeholder="Enter Person Contacted"
                              name="personContacted"
                              value={followUpData.personContacted}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleCloseValidator.current.message(
                                "personContacted",
                                followUpData.personContacted,
                                "required"
                              )}
                            </div>
                          </Col>

                          {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            <Label className={"form-label"}>
                              {"Preferred Language"}
                              <span className="required">*</span>
                            </Label>
                          </div>
                          <Select
                            type="text"
                            name="preferredLanguage"
                            value={preferredLanguage}
                            isMulti
                            onChange={(e) => setPreferredLanguage(e)}
                            options={recordsMetaData.languageOptions}
                            placeholder="Select Preferred Language"
                            classNamePrefix="select2-selection"
                          />
                          <div style={{ textTransform: "capitalize" }}>
                            {simpleCloseValidator.current.message(
                              "preferredLanguage",
                              preferredLanguage,
                              "required"
                            )}
                          </div>
                        </Col> */}
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <Button className=" btn btn-warning  position-relative fs-5" onClick={() =>
                                  handleClickAttachment("desktop")
                                }>
                                  <i className="fas fa-laptop"></i>

                                  <input
                                    type="file"
                                    name="uploadInput"
                                    accept="application/pdf, audio/mp3 , image/jpeg"
                                    id="uploadAttachment"
                                    multiple
                                    onChange={(e) => uploadChange(e, renderPage)}
                                    style={{ display: "none" }}
                                    ref={inputDesktopAttachmentFile}
                                  />
                                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                    {fileLength ? fileLength : 0}
                                  </span>
                                </Button>
                              </div>
                              <div style={{ marginLeft: "40px" }}>
                                <Button
                                  className=" btn btn-info  position-relative fs-5"
                                  onClick={() =>
                                    handleClickAttachment("mobile")
                                  }
                                >
                                  <i className="fas fa-mobile-alt fs-3"></i>

                                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                    {mobileAttachmentSelected.length || 0}
                                  </span>
                                </Button>
                              </div>
                            </div>
                            <div className="text-decoration-underline text-danger">
                              {fileName ? fileName : ""}

                            </div>
                            {/* <div style={{ textTransform: "capitalize" }}>
                              {simpleValidator.current.message(
                                "Attachment",
                                uploadInput,
                                "required"
                              )}
                            </div> */}
                            {attachmentValidation == true &&
                              (uploadInput.length == 0 &&
                                mobileAttachmentSelected.length == 0) ? (
                              <div className="srv-validation-message">
                                The Attachment field is required.
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col md="3" lg="3" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Contacted Person"}
                              >
                                {"Followup Remarks"} {""}{" "}
                                {/* <span className="required">*</span> */}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Followup Remarks"
                              name="followUpRemarks"
                              value={followUpData.followUpRemarks}
                              onChange={(e) => handleFollowUpChange(e)}
                            />
                            {/* <div style={{ textTransform: "capitalize" }}> */}
                            {/* {simpleCloseValidator.current.message(
                              "Followup Remarks",
                              followUpData.followUpRemarks,
                              "required"
                            )}
                          </div> */}
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Followup Reason"}
                              </Label>
                            </div>
                            <Select
                              type="text"
                              isMulti
                              name="followupReason"
                              value={followupReason}
                              onChange={(e) => setFollowupReason(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followupReasonOptions
                                  : []
                              }
                              placeholder="Select Followup Reason"
                              classNamePrefix="select2-selection"
                            />

                          </Col>
                        </Row>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Future Followup
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="quoteInfo123"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="quoteInfo123"
                                >
                                  Future Followup
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row
                          style={{ margin: "10px 0px" }}
                          className="d-flex flex-row ec-followup-form-content"
                        >
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Next Followup  Date & Time"}
                              >
                                {"Next Followup Date & Time"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="datetime-local"
                              placeholder="Select Date"
                              name="nextFollowUpDateAndTime"
                              value={futureFollowUpData.nextFollowUpDateAndTime}
                              min={moment(futureFollowUpData.nextFollowUpDateAndTime).format('YYYY-MM-DDTHH:mm')}
                              max={moment(futureFollowUpData.nextFollowUpDateAndTime).add(13, 'days').format('YYYY-MM-DDTHH:mm')}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                            />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Mode Of Followup"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="futureFollowUpMode"
                              value={futureFollowUpMode}
                              onChange={(e) => setFutureFollowUpMode(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.followUpModeOptions
                                  : []
                              }
                              placeholder="Select Mode Of Followup"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleCloseValidator.current.message(
                                "futureFollowUpMode",
                                futureFollowUpMode,
                                "required"
                              )}
                            </div>
                          </Col>

                          <Col md="4" lg="4" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Contacted Person"}
                              >
                                {"Future Remarks"} {""}{" "}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              placeholder="Enter Remarks"
                              name="remarks"
                              value={futureFollowUpData.remarks}
                              onChange={(e) => handleFutureFollowUpChange(e)}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleCloseValidator.current.message(
                                "Remarks",
                                futureFollowUpData.remarks,
                                "required"
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="9" md="9">
                            <Table responsive striped>
                              <thead>
                                <tr>
                                  <th style={{ width: "70%" }}>
                                    Actions After Closure Call
                                  </th>
                                  <th style={{ width: "30%" }}>Yes/No</th>
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(actionsDetails) ? (
                                  actionsDetails.map((item, index) => (
                                    <tr key={index}>
                                      <td style={{ width: "70%" }}>
                                        {item.criteriaName}
                                      </td>
                                      <td style={{ width: "30%" }}>
                                        <Input
                                          type="checkbox"
                                          style={{
                                            width: "15px",
                                            height: "15px",
                                            marginLeft: "10px",
                                          }}
                                          checked={checkedIntroItems.some(
                                            (checkedItem) =>
                                              checkedItem._id === item._id
                                          )}
                                          onChange={() =>
                                            handleIntroCheckboxChange(item)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <>
                                    <tr key={0}>
                                      <td
                                        colSpan={2}
                                        className="text-align-center"
                                      >
                                        No record found
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Deliverable Status section
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="xy1"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="xy1"
                                >
                                  Deliverable Status section
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12" xl="12" lg="12" className="mt-3">
                            <Table responsive striped>
                              <thead>
                                <tr>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Product Name</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Applicable Events</th>
                                  <th style={{ minWidth: "50px", maxWidth: "80px" }}>Qty</th>
                                  <th style={{ minWidth: "120px", maxWidth: "120px" }}>Deliverable Status</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>TAT Date</th>
                                  <th style={{ minWidth: "100px", maxWidth: "100px" }}>Hints Name</th>
                                  <th style={{ minWidth: "300px", maxWidth: "300px" }}>Hints</th> {/* Increased width */}
                                  <th style={{ minWidth: "300px", maxWidth: "300px" }}>Remarks</th> {/* Increased width */}
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(deliverableStatusSectionData) ? (
                                  deliverableStatusSectionData.map(
                                    (item, index) => {
                                      const hintsName = item.hintsId.length > 0
                                        ? item.hintsId.map((id, idx) => item.hintsName[idx])
                                        : "--"
                                      const hintsIdOptions = !isEmpty(hintsOptions) ? hintsOptions.filter(m => m.productCategoryId == item.productCategoryId) : []

                                      return (
                                        <tr key={index}>

                                          <td>
                                            {item.productName
                                              ? item.productName
                                              : "--"}
                                          </td>

                                          <td>{item.applicableEvents}</td>
                                          <td>{item.quantity}</td>
                                          <td>{item.deliverableStatus}</td>
                                          <td>
                                            {item.tatDate ? item.tatDate : "--"}
                                          </td>
                                          <td>{hintsName}</td>
                                          <td style={{ textAlign: "center" }}>
                                            {/* <Select
                                            type="text"
                                            name="hintsId"
                                            isMulti
                                            value={
                                              item.hintsId
                                                ? {
                                                  value: item.hintsId,
                                                  label: item.hintsName,
                                                }
                                                : { value: "", label: "Select" }
                                            }
                                            options={hintsOptions}
            
                                            onChange={(e) =>
                                              modalChange(e, index, "hintsId")
                                            }
                                            placeholder="Select Status"
                                            classNamePrefix="select2-selection"
                                          /> */}
                                            <Select
                                              type="text"
                                              name="hintsId"
                                              isMulti
                                              value={
                                                item.hintsId.length > 0
                                                  ? item.hintsId.map(
                                                    (id, idx) => ({
                                                      value: id,
                                                      label:
                                                        item.hintsName[idx], // Assuming hintsName is also an array
                                                    })
                                                  )
                                                  : []
                                              }
                                              onChange={(e) =>
                                                modalChange(e, index, "hintsId")
                                              }
                                              placeholder="Select Hints"
                                              classNamePrefix="select2-selection"
                                              options={hintsIdOptions}
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                multiValue: (styles, { data }) => {
                                                  const isGrey = item.highlightedHints?.includes(data.value)
                                                  return {
                                                    ...styles,
                                                    backgroundColor: isGrey ? "grey" : "lightcoral",

                                                  }
                                                },
                                                multiValueLabel: (styles) => ({
                                                  ...styles,
                                                  color: "white",
                                                }),
                                                multiValueRemove: (styles, { data }) => ({
                                                  ...styles,
                                                  cursor: "pointer",
                                                  ":hover": {
                                                    backgroundColor: item.highlightedHints?.includes(data.value) ? "darkgrey" : "darkred",
                                                    color: "white",
                                                  },
                                                }),
                                              }}
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="textarea"
                                              name="remarks"
                                              value={item.remarks}
                                              onChange={(e) =>
                                                modalChange(e, index, "remarks")
                                              }
                                              placeholder="Enter Remarks"
                                            />
                                          </td>
                                        </tr>
                                      )
                                    }
                                  )
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={8}
                                      className="text-align-center"
                                    >
                                      No Records Found..
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>

                        <Row className="quote-head-content">
                          <Col
                            lg="9"
                            md="9"
                            sm="6"
                            xs="6"
                            className="d-flex flex-row"
                          >
                            <p className="quote-head">
                              Issues
                              <span className="quote-info">
                                <i
                                  style={{ color: "grey" }}
                                  id="xy12"
                                  aria-hidden="true"
                                  className="fa fa-info-circle ms-1"
                                ></i>
                                <UncontrolledTooltip
                                  placement="right"
                                  target="xy12"
                                >
                                  Issues
                                </UncontrolledTooltip>
                              </span>
                            </p>
                          </Col>
                          {isEdit === false && (
                            <Col lg="3" md="3" sm="12">
                              <button
                                onClick={addIssues}
                                type="button"
                                className={"btn btn-info"}
                                style={{ float: "right" }}
                              >
                                Add More
                              </button>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col sm="12" xl="12" lg="12" className="mt-3">
                            {isEdit === false && (
                              <Table responsive striped>
                                <thead>
                                  <tr>
                                    <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                      Department{" "}
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Issue Description
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Internal Followup Comments
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Next Followup Date
                                    </th>
                                    <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                                      POC (Emp Name)
                                    </th>
                                    <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                      Solution Offered
                                    </th>
                                    <th>#</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {!isEmpty(issuesData) ? (
                                    issuesData.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td style={{ textAlign: "center" }}>
                                            <Select
                                              type="text"
                                              name="departmentId"
                                              value={
                                                item.departmentId
                                                  ? {
                                                    value: item.departmentId,
                                                    label: item.department,
                                                  }
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "departmentId"
                                                )
                                              }
                                              isClearable
                                              placeholder="Select Department"
                                              classNamePrefix="select2-selection"
                                              options={
                                                recordsMetaData.departmentOptions
                                              }
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                              }}
                                            />
                                            <div
                                              style={{
                                                fontSize: "10px",
                                                textAlign: "left",
                                              }}
                                            >
                                              {validateDepartment &&
                                                isEmpty(item.departmentId) && (
                                                  <p className="required">
                                                    Department Field Is Required
                                                  </p>
                                                )}
                                            </div>
                                          </td>

                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="text"
                                              name="issueDescription"
                                              value={item.issueDescription}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "issueDescription"
                                                )
                                              }
                                              placeholder="Enter Issue Description"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="text"
                                              name="followUpComments"
                                              value={item.followUpComments}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "followUpComments"
                                                )
                                              }
                                              placeholder="Enter Followup Comments"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="date"
                                              name="nextFollowUpDate"
                                              value={item.nextFollowUpDate}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "nextFollowUpDate"
                                                )
                                              }
                                              placeholder="Enter"
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Select
                                              type="text"
                                              name="empId"
                                              isMulti
                                              value={
                                                item.empId.length > 0
                                                  ? item.empId.map(
                                                    (id, idx) => ({
                                                      value: id,
                                                      label:
                                                        item.empName[idx], // Assuming empName is also an array
                                                    })
                                                  )
                                                  : []
                                              }
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "empId"
                                                )
                                              }
                                              placeholder="Select Poc"
                                              classNamePrefix="select2-selection"
                                              options={
                                                recordsMetaData.employeeOptions
                                              }
                                              menuPortalTarget={document.body}
                                              styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                              }}
                                            />
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Input
                                              type="test"
                                              name="solutionOffered"
                                              value={item.solutionOffered}
                                              onChange={(e) =>
                                                issuesModalChange(
                                                  e,
                                                  index,
                                                  "solutionOffered"
                                                )
                                              }
                                              placeholder="Enter Solution Offered"
                                            />
                                          </td>

                                          <td>
                                            {" "}
                                            <i
                                              className="fa fa-times remove-icon"
                                              onClick={() =>
                                                removeIssuesdetails(index)
                                              }
                                            ></i>{" "}
                                          </td>
                                        </tr>
                                      )
                                    })
                                  ) : (
                                    <tr key={0}>
                                      <td
                                        colSpan={8}
                                        className="text-align-center"
                                      >
                                        No Records Found..
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            )}
                            {isEdit === true && (
                              <Col sm="12" xl="12" lg="12" className="mt-3">
                                <Table responsive striped>
                                  <thead>
                                    <tr>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        Department{" "}
                                      </th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        Issue Description
                                      </th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>Internal Followup Comments</th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>Next Followup Date</th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        POC (Emp Name)
                                      </th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>Solution Offered</th>
                                      <th style={{ minWidth: "150px", maxWidth: "150px" }}>Created Date</th>
                                      <th style={{ minWidth: "150px", maxWidth: "150px" }}>Last Updated Date</th>
                                      <th style={{ minWidth: "250px", maxWidth: "250px" }}>
                                        Current Status
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {issuesListData &&
                                      issuesListData.length > 0 &&
                                      issuesListData.map((item, index) => {
                                        return (
                                          <tr key={index}>
                                            <td style={{ textAlign: "center" }}>
                                              <Select
                                                type="text"
                                                name="departmentId"
                                                value={
                                                  item.departmentId
                                                    ? {
                                                      value:
                                                        item.departmentId,
                                                      label: item.department,
                                                    }
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "departmentId"
                                                  )
                                                }
                                                isClearable
                                                placeholder="Select Department"
                                                classNamePrefix="select2-selection"
                                                options={
                                                  recordsMetaData.departmentOptions
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                              <div
                                                style={{
                                                  fontSize: "10px",
                                                  textAlign: "left",
                                                }}
                                              >
                                                {validateUpdateDepartment &&
                                                  isEmpty(
                                                    item.departmentId
                                                  ) && (
                                                    <p className="required">
                                                      Department Field Is
                                                      Required
                                                    </p>
                                                  )}
                                              </div>
                                            </td>

                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="issueDescription"
                                                value={item.issueDescription}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "issueDescription"
                                                  )
                                                }
                                                placeholder="Enter Issue Description"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="followUpComments"
                                                value={item.followUpComments}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "followUpComments"
                                                  )
                                                }
                                                placeholder="Enter Followup Comments"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="date"
                                                name="nextFollowUpDate"
                                                value={item.nextFollowUpDate}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "nextFollowUpDate"
                                                  )
                                                }
                                                placeholder="Enter"
                                              />
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Select
                                                type="text"
                                                name="empId"
                                                isMulti
                                                value={
                                                  item.empId.length > 0
                                                    ? item.empId.map(
                                                      (id, idx) => ({
                                                        value: id,
                                                        label:
                                                          item.empName[idx],
                                                      })
                                                    )
                                                    : []
                                                }
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "empId"
                                                  )
                                                }
                                                placeholder="Select Poc"
                                                classNamePrefix="select2-selection"
                                                options={
                                                  recordsMetaData.employeeOptions
                                                }
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                              {/* <Select

                                    type="text"
                                    name="empId"
                                    isMulti
                                    value={
                                      item.empId
                                        ? {
                                          value: item.empId,
                                          label: item.empName
                                        }
                                        : ""
                                    }
                                    onChange={(e) =>
                                      issuesListModalChange(e, index, "empId")
                                    }
                                    placeholder="Select Poc"
                                    classNamePrefix="select2-selection"
                                    options={recordsMetaData.employeeOptions}
                                  /> */}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Input
                                                type="text"
                                                name="solutionOffered"
                                                value={item.solutionOffered}
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "solutionOffered"
                                                  )
                                                }
                                                placeholder="Enter Solution Offered"
                                              />
                                            </td>
                                            <td>
                                              {item.createdDate
                                                ? moment(
                                                  item.createdDate
                                                ).format(dateFormate)
                                                : ""}
                                            </td>
                                            <td>{item.lastUpdatedDate}</td>
                                            <td>
                                              <Select
                                                type="text"
                                                name="currentStatusValue"
                                                value={
                                                  item.currentStatusValue
                                                    ? {
                                                      value:
                                                        item.currentStatusValue,
                                                      label:
                                                        item.currentStatusName,
                                                    }
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  issuesListModalChange(
                                                    e,
                                                    index,
                                                    "currentStatusValue"
                                                  )
                                                }
                                                placeholder="Select"
                                                classNamePrefix="select2-selection"
                                                options={[
                                                  {
                                                    label: "Pending",
                                                    value: "Pending",
                                                  },
                                                  {
                                                    label: "Resolved",
                                                    value: "Resolved",
                                                  },
                                                ]}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                              />
                                            </td>
                                          </tr>
                                        )
                                      })}
                                  </tbody>
                                </Table>
                              </Col>
                            )}
                          </Col>
                          <Col md="12" xl="12" lg="12" className="mt-5 mb-3">
                            <div
                              style={{ float: "right" }}
                              className="d-flex flex-row"
                            >
                              <Button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => {
                                  setECFollowupModal(false)
                                  clearFollowupModal()
                                  // resetDeliverableStatusSectionData()
                                }}
                              >
                                Cancel
                              </Button>
                              {isEdit ? (
                                <Button
                                  type="button"
                                  variant="primary"
                                  className="btn btn-success mx-2"
                                  onClick={() => {
                                    updateClosureFollowup()
                                  }}
                                >
                                  Update
                                </Button>
                              ) : (
                                <Button
                                  type="button"
                                  variant="primary"
                                  className="btn btn-success mx-2"
                                  onClick={(e) => {
                                    addClosure(e)
                                  }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    ))}
                  {dropDownModal && (
                    <Modal show={dropDownModal} size="md">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Follow Up
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Select
                            type="text"
                            name="followUpModalDetails"
                            value={followUpModalDetails}
                            onChange={(e) => setFollowUpModalDetails(e)}
                            options={[
                              { label: "Intro Call", value: "Intro Call" },
                              { label: "Followup", value: "Followup" },
                              { label: "Escalation", value: "Escalation" },
                              { label: "Closure Call", value: "Closure Call" },
                            ]}
                            placeholder="Select Follow Up"
                            classNamePrefix="select2-selection"
                          />
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <div>
                          <Button
                            type="submit"
                            onClick={() => {
                              setDropDownModal(false)
                              setSelectOpen(false)
                              setDropdownValue([])
                              setECFollowupModal(false)
                            }}
                            style={{ fontSize: "10px", marginLeft: "20px" }}
                            className="btn btn-danger buttons"
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              addFollowupModalDetails()
                              // clearFollowUp()
                              setTimeout(() => {
                                setDropDownModal(false)
                              }, 200)
                            }}
                            style={{ fontSize: "10px", marginLeft: "20px" }}
                            className="btn btn-success buttons"
                          >
                            {" "}
                            Confirm
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {/* mobile attachment modal */}
                  {mobileAttachmentForm && (
                    <Modal
                      show={mobileAttachmentForm}
                      onHide={handleCloseAttachment}
                      size="lg"
                      style={{
                        backgroundColor: "#2a2a2bfa",
                        opacity: 1.5,
                      }}
                    >
                      <Modal.Header>
                        <h4>Mobile Attachment Details</h4>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className="event-label">Search</Label>
                            </div>
                            <Input
                              type="date"
                              name="date"
                              placeholder="Select Date"
                              value={mobileData.date}
                              onChange={(e) => handleMobileChange(e)}
                            />
                            <br />
                            <br />
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-4">
                            <Button onClick={(e) => handleMobileSearch(e)}
                              className="btn btn-info" style={{marginTop:"15px",marginRight:"20px"}}>Search</Button>
                                <Button onClick={(e) => handleMobileReset(e)}
                              className="btn btn-danger" style={{marginTop:"15px"}}>Reset</Button>
                          </Col>

                          <Col lg="12" md="12" sm="12" xs="12">
                            <Table bordered responsive>
                              <thead>
                                <tr>
                                  <th>Sl.No</th>
                                  <th>Date &#38; Time</th>
                                  <th>Customer Name</th>
                                  <th>Description</th>
                                  <th>Attachment</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {attachmentRecordUpdated &&
                                  attachmentRecordUpdated.length > 0 ? (
                                  attachmentRecordUpdated.map((item) => {
                                    return (
                                      <>
                                        <tr key={item.key}>
                                          <td>{item.key + 1}</td>
                                          <td>{item.pickDateTime}</td>
                                          <td>{item.customerDetails}</td>
                                          <td>{item.description}</td>
                                          <td>
                                            {item.attachmentType == "image" ? (
                                              <object
                                                data={item.attachment}
                                                type="image/png"
                                                width="120"
                                                height="90"
                                              >
                                                <img
                                                  src={imageNotFound}
                                                  width="120"
                                                  height="90"
                                                />
                                              </object>
                                            ) : (
                                              ""
                                            )}

                                            {item.attachmentType == "audio" ? (
                                              <audio controls>
                                                <source
                                                  src={item.attachment}
                                                  type="audio/mpeg"
                                                />
                                                Your browser does not support
                                                the audio element.
                                              </audio>
                                            ) : (
                                              ""
                                            )}
                                            <br />
                                            <br />
                                            <a href={item.attachment} download>
                                              download
                                            </a>
                                          </td>
                                          <td>
                                            <div>
                                              <Input
                                                type="checkbox"
                                                className="form-check-input checkbox-attachment"
                                                name="checkbox"
                                                onChange={(e) =>
                                                  handleChangeAttachmentCheckbox(
                                                    e,
                                                    item.id,
                                                    item.attachment
                                                  )
                                                }
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      </>
                                    )
                                  })
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={5}
                                      className="text-align-center"
                                    >
                                      {"No Data Found"}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={handleCloseAttachment}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={(event) => {
                            handleSubmitAttachment(event)
                          }}
                        >
                          Upload
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  <ToastContainer
                    position="top-right"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </React.Fragment>
              )
            case "Issues Followup":
              return (
                <Col>
                  <OperationsIssuesTab />
                </Col>
              )
          }
        })()}
        {followupStatusModal && (
          <Modal size="md" show={followupStatusModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Confirm
            </Modal.Header>
            <Modal.Body>
              Are You Sure Do You Want To Close Followup Status?
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setFollowupStatusModal(false)}
              >
                No
              </Button>
              <Button
                variant="secondary"
                className="btn btn-success"
                data-bs-dismiss="modal"
                onClick={() => submitFollowup()}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Row>
    </React.Fragment>
  )
}

OperationsFollowup.propTypes = {
  dispatch: PropTypes.func,
  clientProfile: PropTypes.array,
  location: PropTypes.array,
  modeMenu: PropTypes.any,
  record_client_profile: PropTypes.object
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OperationsFollowup)
)
